import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Alert, Box, Typography, useTheme, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Tooltip, TextField, FormControl, InputLabel, Select, MenuItem, CardContent, CardActions, CardMedia, Card, Chip, SelectChangeEvent,
    CircularProgress,
    Divider,
    Slide,
    Avatar,
    Snackbar,
    Fade,
    InputAdornment,
    Link,
} from "@mui/material";
import { Assignment, LocalGroceryStore, Inventory, Close, Route as RouteIcon, Home, PictureAsPdf, Edit, SettingsApplications } from "@mui/icons-material";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {
    Search as SearchIcon,
    FilterList as FilterIcon,
    Edit as EditIcon,
    Visibility as VisibilityIcon,
    LocalShipping,
    Upload,
    AttachFile,
    Clear
} from '@mui/icons-material';
import { Transportista, RouteGroup, Route } from "../models";
import { collection, query, where, getDocs, Timestamp, doc, getDoc, getFirestore, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getYear, getMonth, getDate } from 'date-fns';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteIcon from '@mui/icons-material/Note';
import RecyclingIcon from '@mui/icons-material/Recycling';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { FaWaze } from 'react-icons/fa';
import GoogleIcon from '@mui/icons-material/Google';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
// Add these imports at the top
import { keyframes } from '@mui/system';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FieldValue, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { debounce } from 'lodash';
import { on } from "events";
// At the top of the file, add:
import { useNavigate } from 'react-router-dom';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

const StyledSelect = styled('select')(({ theme }) => ({
    width: '100%',
    padding: '15px 25px',
    fontSize: '1.2rem',
    borderRadius: '12px',
    outline: 'none',
    cursor: 'pointer',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    transition: 'all 0.3s ease',
    textAlign: 'center',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    appearance: 'none',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\'%3E%3Cpath fill=\'%232a5298\' d=\'M7 10l5 5 5-5z\'/%3E%3C/svg%3E")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 15px center',
    background: 'linear-gradient(to right, rgba(42, 82, 152, 0.05), rgba(255, 255, 255, 0.95))',
    color: '#2a5298',
    border: '1px solid rgba(42, 82, 152, 0.2)',
    boxShadow: '0 2px 10px rgba(42, 82, 152, 0.08)',

    '&:hover': {
        background: 'linear-gradient(to right, rgba(42, 82, 152, 0.08), rgba(255, 255, 255, 0.98))',
        border: '1px solid rgba(42, 82, 152, 0.3)',
        boxShadow: '0 4px 15px rgba(42, 82, 152, 0.12)'
    },

    '&:disabled': {
        background: 'linear-gradient(to right, rgba(42, 82, 152, 0.02), rgba(255, 255, 255, 0.9))',
        color: 'rgba(42, 82, 152, 0.5)',
        border: '1px solid rgba(42, 82, 152, 0.1)',
        boxShadow: 'none',
        cursor: 'not-allowed'
    }
}));

// Add wrapper component
const PageWrapper = styled('div')({
    display: 'grid',
    placeItems: 'center',
    minHeight: '80vh',
    width: '100%',
    padding: 0,
    margin: 0,
    overflow: 'hidden',
    background: 'linear-gradient(135deg, rgba(0, 180, 216, 0.05) 0%, rgba(255, 255, 255, 0.1) 100%)'
});

const GlassContainer = styled(Box)(({ theme }) => ({
    width: '90%',
    maxWidth: '600px',
    margin: '0 auto',
    padding: theme.spacing(3),
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px rgba(0, 180, 216, 0.15)',
    // animation: `${fadeIn} 0.5s ease-out`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(0, 180, 216, 0.2)',
    [theme.breakpoints.down('sm')]: {
        width: '95%',
        padding: theme.spacing(2),
        minHeight: '70vh'
    }
}));

const GlassBox = styled(Box)(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(3),
    background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.95))',
    backdropFilter: 'blur(20px)',
    borderRadius: '20px',
    border: '1px solid rgba(0, 180, 216, 0.15)',
    boxShadow: '0 4px 20px rgba(0, 180, 216, 0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 30px rgba(0, 180, 216, 0.2)',
        border: '1px solid rgba(0, 180, 216, 0.25)'
    }
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
    color: 'rgb(0, 180, 216)',
    textAlign: 'center',
    fontSize: '2.2rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    marginBottom: theme.spacing(3),
    textShadow: '0 2px 4px rgba(0, 180, 216, 0.1)',
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.8rem'
    }
}));

// // Add animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// const gradientShift = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;
// // Add these animations
const checkAnimation = keyframes`
  0% { transform: scale(0) rotate(0deg); opacity: 0; }
  50% { transform: scale(1.2) rotate(180deg); }
  100% { transform: scale(1) rotate(360deg); opacity: 1; }
`;

const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

interface NotificationState {
    open: boolean;
    message: string;
    type: 'success' | 'error';
}

// 1. Add new enum for dialog types
enum ActiveDialog {
    NONE = 'NONE',
    PEDIDOS = 'PEDIDOS',
    PRODUCTOS = 'PRODUCTOS',
    INVENTARIO = 'INVENTARIO',
    CLIENTE_DETAILS = 'CLIENTE_DETAILS',
    VIEW_DETAILS = 'VIEW_DETAILS',
    VIEW_DETAILS_ORDER = 'VIEW_DETAILS_ORDER',
    DELEVARY = 'DELEVARY',
}

type RouteUnion = [Route[], Date | Timestamp, boolean];

interface ClientInfo {
    clientId: string;
    name: string;
    provincia: string;
    canton: string;
    distrito: string;
    delivery_completed: boolean;
    status?: 'completed' | 'cancelled';
}

// 1. Add new interfaces after existing interfaces
interface DeliveryFormData {
    numContainers: number;
    containerValues: string[];
    driverNote: string;
    deliveryFile: File | null;
}


// 1. Add new interface for items with order quantity
interface OrderInventoryItem extends InventoryItem {
    orderQuantity: number;
    clientId: string;
    routeId: string;
    delivery_completed?: boolean;
}

interface Client {
    id: string;
    name: string;
    provincia: string;
    canton: string;
    distrito: string;
    cedula_nacional: string;
    phoneNumber: string;
    tipo_client: string;
    tipo_compostera: string;
    senas?: string;
    email?: string;
    googleMapsLink?: string;
    wazeLink?: string;
    second_phoneNumber?: string;
}

interface OperacionesDashboardProps {
    transportistaCorreo: string;
    inventoryItems: InventoryItem[];
    handleLogout: () => void;
}

interface InventoryItem {
    id: string;
    name: string;
    price: number;
    quantity: number;
    imageUrl: string;
    category: string;
    description?: string;
    color?: string;
    tamano?: string;
}

interface RoutesUnion {
    routes: Route[];
    date: string;
    isActive: boolean;
}

// 1. Add new interfaces and types
interface DeliveryStatus {
    isCompleted: boolean;
    containerValues: string[];
    driverNote: string;
    completedAt?: Timestamp | FieldValue;
    status?: 'completed' | 'cancelled';
}

// Add after existing animations:
const checkFadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8) rotate(-45deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
`;

// Add these animations
const gradientAnimation = keyframes`
  0% { background-position: 0% 50% }
  50% { background-position: 100% 50% }
  100% { background-position: 0% 50% }
`;

// Add new styled components
const ClientCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    }
}));

interface FormState {
    driverNote: string;
}


const MemoizedTextField = React.memo(({ value, onChange, rows = 4, ...props }: any) => (
    <TextField
        {...props}
        value={value}
        onChange={onChange}
        rows={rows} // Ensure this is a number
        multiline
        sx={{
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff',
                '&.Mui-focused fieldset': {
                    borderColor: '#00b4d8'
                },
                '@media (max-width: 600px)': {
                    fontSize: '16px',
                    '& textarea': {
                        padding: '12px'
                    }
                }
            }
        }}
    />
));


// Add transition component
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return (
        <Fade
            ref={ref}
            {...props}
            timeout={0} // Set timeout to 0
            style={{
                transition: 'none' // Disable transition
            }}
        />
    );
});

// Actualizar la interfaz DeliveryDialogProps
interface DeliveryDialogProps {
    open: boolean;
    onClose: () => void;
    formData: DeliveryFormData;
    setFormData: (data: DeliveryFormData | ((prev: DeliveryFormData) => DeliveryFormData)) => void;
    onSubmit: (status: 'completed' | 'cancelled') => void;
    isEdit?: boolean;
    existingFileUrl: string | null;
    deliveryStatus?: DeliveryStatus;
}

const DeliveryDialog = React.memo(({ open, onClose, formData, setFormData, onSubmit, isEdit = false, existingFileUrl, deliveryStatus }: DeliveryDialogProps) => {
    // Local state for note to prevent input lag
    const [noteValue, setNoteValue] = useState(formData.driverNote);

    // Debounced update to parent state
    const debouncedSetFormData = useCallback(
        debounce((value: string) => {
            setFormData({
                ...formData,
                driverNote: value
            });
        }, 300),
        [formData, setFormData]
    );

    // Optimized note change handler
    const handleNoteChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = e.target.value;
        setNoteValue(newValue);
        debouncedSetFormData(newValue);
    }, [debouncedSetFormData]);

    // Reset note value when dialog opens/closes
    useEffect(() => {
        setNoteValue(formData.driverNote);
    }, [formData.driverNote, open]);

    return (
        <Dialog
            open={open}
            TransitionProps={{
                unmountOnExit: false,
                mountOnEnter: false
            }}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            TransitionComponent={Transition} // Re-enable the optimized Transition
            transitionDuration={0} // Set duration to 0
            keepMounted // Keep dialog mounted to prevent re-renders
            PaperProps={{
                sx: {
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                    transition: 'none', // Remove transition
                    transform: 'none !important', // Remove transform
                    maxWidth: '900px',
                    width: '91%',
                    margin: '8px',
                    mt: '-104px',
                    '&:hover': {
                        boxShadow: '0 12px 48px rgba(0, 0, 0, 0.16)'
                    },
                    height: '86vh !important',
                    // Custom scrollbar styling
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        backgroundColor: 'transparent'
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0, 180, 216, 0.05)',
                        borderRadius: '10px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgb(0, 180, 216)',
                        borderRadius: '10px',
                        border: '2px solid transparent',
                        backgroundClip: 'content-box',
                        '&:hover': {
                            backgroundColor: 'rgb(0, 119, 182)',
                            cursor: 'pointer'
                        }
                    },
                    // Firefox scrollbar styling
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'rgb(0, 180, 216) rgba(0, 180, 216, 0.05)'
                }
            }}
        >
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2.5
                }}
            >
                <Typography variant="h5" component="div" fontWeight="700" sx={{ letterSpacing: '0.5px' }}>
                    {isEdit ? 'Editar Entrega' : 'Completar Entrega'}
                </Typography>
                <IconButton onClick={onClose} sx={{
                    color: 'white',
                    transition: 'all 0.3s ease',
                    "&:hover": {
                        transform: 'rotate(90deg) scale(1.1)',
                        backgroundColor: 'rgba(255, 255, 255, 0.15)'
                    }
                }}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <span />
            <DialogContent sx={{ p: 4 }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                    '& .MuiTextField-root': {
                        transition: 'all 0.3s ease'
                    }
                }}>
                    <MemoizedTextField
                        key="delivery-note-input"
                        value={noteValue}
                        onChange={handleNoteChange}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4} // Ensure this is a number
                        placeholder="Escriba aquí la nota de entrega..."
                        helperText="Ingrese la nota de entrega"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                borderRadius: { xs: 1, sm: 2 },
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                minHeight: { xs: '100px', sm: 'auto' },
                                '& textarea': {
                                    fontSize: { xs: '16px', sm: 'inherit' },
                                    padding: { xs: 1.5, sm: 2 }
                                },
                                '&:hover': {
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                },
                                '&.Mui-focused': {
                                    boxShadow: '0 4px 12px rgba(0,180,216,0.15)'
                                },
                                '@media (hover: none)': {
                                    '&:hover': {
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                    }
                                }
                            },
                            '& .MuiFormHelperText-root': {
                                marginLeft: 1,
                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                color: 'text.secondary'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: { xs: '14px', sm: 'inherit' }
                            }
                        }}
                    />
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            bgcolor: 'rgba(0, 180, 216, 0.02)',
                            borderRadius: 3,
                            border: '1px solid rgba(0, 180, 216, 0.1)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                bgcolor: 'rgba(0, 180, 216, 0.05)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{
                                fontWeight: 600,
                                color: 'rgb(0, 180, 216)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2,
                                justifyContent: 'center'
                            }}
                        >
                            <LocalShipping sx={{ fontSize: 24 }} />
                            Comprobante de Entrega
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <input
                                accept="image/*,.pdf"
                                style={{ display: 'none' }}
                                id="delivery-file-upload"
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        // Verificar el tamaño (máximo 5MB)
                                        if (file.size > 5 * 1024 * 1024) {
                                            // setNotification({
                                            //     open: true,
                                            //     message: 'El archivo no debe superar los 5MB',
                                            //     type: 'error'
                                            // });
                                            return;
                                        }

                                        // Verificar el tipo de archivo
                                        const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
                                        if (!validTypes.includes(file.type)) {
                                            // setNotification({
                                            //     open: true,
                                            //     message: 'Formato no válido. Use: JPG, PNG, GIF o PDF',
                                            //     type: 'error'
                                            // });
                                            return;
                                        }

                                        // Aquí puedes manejar el archivo válido
                                        setFormData({
                                            ...formData,
                                            deliveryFile: file
                                        });
                                    }
                                }}
                            />

                            {existingFileUrl && (
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                    width: '100%'
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        color: 'text.secondary',
                                        width: '100%',
                                        bgcolor: 'rgba(0, 180, 216, 0.05)',
                                        p: 2,
                                        borderRadius: 1
                                    }}>
                                        <AttachFile sx={{ fontSize: 20 }} />
                                        <Typography variant="body2" sx={{ flex: 1 }}>
                                            Comprobante actual
                                        </Typography>
                                        <Link
                                            href={existingFileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                color: 'primary.main',
                                                textDecoration: 'none',
                                                '&:hover': { textDecoration: 'underline' }
                                            }}
                                        >
                                            Ver archivo
                                        </Link>
                                    </Box>

                                    {/* Preview for existing image */}
                                    {existingFileUrl.match(/\.(jpg|jpeg|png|gif)$/i) && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflow: 'hidden',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                position: 'relative'
                                            }}
                                        >
                                            <img
                                                src={existingFileUrl}
                                                alt="Comprobante actual"
                                                style={{
                                                    width: '100%',
                                                    height: '200px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </Box>
                                    )}

                                    {/* Preview for existing PDF */}
                                    {existingFileUrl.match(/\.pdf$/i) && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                p: 2,
                                                bgcolor: 'background.paper',
                                                borderRadius: 2,
                                                border: '1px solid rgba(0, 180, 216, 0.2)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2
                                            }}
                                        >
                                            <PictureAsPdf sx={{ fontSize: 40, color: 'error.main' }} />
                                            <Box>
                                                <Typography variant="subtitle2" color="text.primary">
                                                    Documento PDF
                                                </Typography>
                                                <Link
                                                    href={existingFileUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    sx={{
                                                        color: 'primary.main',
                                                        textDecoration: 'none',
                                                        '&:hover': { textDecoration: 'underline' }
                                                    }}
                                                >
                                                    Ver PDF
                                                </Link>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            )}


                            {formData.deliveryFile && (
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                    width: '100%'
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        color: 'text.secondary',
                                        width: '100%',
                                        bgcolor: 'rgba(0, 180, 216, 0.05)',
                                        p: 2,
                                        borderRadius: 1
                                    }}>
                                        <AttachFile sx={{ fontSize: 20 }} />
                                        <Typography variant="body2" sx={{ flex: 1 }}>
                                            {formData.deliveryFile.name}
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                setFormData({
                                                    ...formData,
                                                    deliveryFile: null
                                                });
                                            }}
                                            sx={{
                                                color: 'error.main',
                                                '&:hover': {
                                                    bgcolor: 'error.light',
                                                    color: 'error.contrastText'
                                                }
                                            }}
                                        >
                                            <Clear sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </Box>

                                    {/* Vista previa de imagen */}
                                    {formData.deliveryFile.type.startsWith('image/') && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflow: 'hidden',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                position: 'relative'
                                            }}
                                        >
                                            <img
                                                src={URL.createObjectURL(formData.deliveryFile)}
                                                alt="Vista previa"
                                                style={{
                                                    width: '100%',
                                                    height: '200px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        </Box>
                                    )}

                                    {/* Vista previa de PDF */}
                                    {formData.deliveryFile.type === 'application/pdf' && (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                p: 2,
                                                bgcolor: 'background.paper',
                                                borderRadius: 2,
                                                border: '1px solid rgba(0, 180, 216, 0.2)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2
                                            }}
                                        >
                                            <PictureAsPdf sx={{ fontSize: 40, color: 'error.main' }} />
                                            <Box>
                                                <Typography variant="subtitle2" color="text.primary">
                                                    Documento PDF
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {(formData.deliveryFile.size / 1024 / 1024).toFixed(2)} MB
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            )}

                            <label htmlFor="delivery-file-upload">
                                <Button
                                    component="span"
                                    variant={existingFileUrl ? "outlined" : "contained"}
                                    startIcon={existingFileUrl ? <Edit /> : <Upload />}
                                    sx={{
                                        fontSize: '13px',
                                        borderColor: existingFileUrl ? 'rgba(0, 180, 216, 0.5)' : undefined,
                                        color: existingFileUrl ? 'rgb(0, 180, 216)' : 'white',
                                        bgcolor: existingFileUrl ? 'transparent' : 'rgb(0, 180, 216)',
                                        '&:hover': {
                                            borderColor: existingFileUrl ? 'rgb(0, 180, 216)' : undefined,
                                            bgcolor: existingFileUrl
                                                ? 'rgba(0, 180, 216, 0.05)'
                                                : 'rgb(0, 119, 182)'
                                        }
                                    }}
                                >
                                    {existingFileUrl ? 'Cambiar comprobante' : 'Subir Comprobante'}
                                </Button>
                            </label>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                align="center"
                                sx={{ mt: 1 }}
                            >
                                Formatos permitidos: JPG, PNG, GIF, PDF (máx. 5MB)
                            </Typography>
                        </Box>
                    </Paper>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            bgcolor: 'rgba(0, 180, 216, 0.02)',
                            borderRadius: 3,
                            border: '1px solid rgba(0, 180, 216, 0.1)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                bgcolor: 'rgba(0, 180, 216, 0.05)',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                            }
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{
                                fontWeight: 600,
                                color: 'rgb(0, 180, 216)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: 2,
                                justifyContent: 'center'
                            }}
                        >
                            <SettingsApplications sx={{ fontSize: 24 }} />
                            Configuración de Entrega
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            mb: 2
                        }}>
                            <IconButton
                                onClick={() => {
                                    const newNum = Math.max(formData.numContainers - 1, 1);
                                    setFormData({
                                        ...formData,
                                        numContainers: newNum,
                                        containerValues: Array(newNum).fill('').map((_, i) => formData.containerValues[i] || '')
                                    });
                                }}
                                disabled={formData.numContainers <= 1}
                                sx={{
                                    '&:hover': { bgcolor: 'action.hover' },
                                    color: 'primary.main'
                                }}
                                aria-label="Reducir contenedores"
                            >
                                <RemoveCircleOutline />
                            </IconButton>

                            <TextField
                                fullWidth
                                label="Cantidad"
                                value={formData.numContainers}
                                variant="outlined"
                                InputProps={{
                                    startAdornment: <Box component="span" sx={{ mr: 1, fontSize: '240%' }}>📦</Box>,
                                    inputProps: {
                                        min: 1,
                                        max: 8,
                                        style: { textAlign: 'left' }
                                    }
                                }}
                                helperText={`Máximo 8 contenedores (${formData.numContainers}/8)`}
                                onChange={(e) => {
                                    const num = Math.min(Math.max(parseInt(e.target.value) || 1, 1), 8);
                                    setFormData({
                                        ...formData,
                                        numContainers: num,
                                        containerValues: Array(num).fill('').map((_, i) => formData.containerValues[i] || '')
                                    });
                                }}
                            />

                            <IconButton
                                onClick={() => {
                                    const newNum = Math.min(formData.numContainers + 1, 8);
                                    setFormData({
                                        ...formData,
                                        numContainers: newNum,
                                        containerValues: Array(newNum).fill('').map((_, i) => formData.containerValues[i] || '')
                                    });
                                }}
                                disabled={formData.numContainers >= 8}
                                sx={{
                                    '&:hover': { bgcolor: 'action.hover' },
                                    color: 'primary.main'
                                }}
                                aria-label="Agregar contenedor"
                            >
                                <AddCircleOutline />
                            </IconButton>
                        </Box>
                        <Grid container spacing={3}>
                            {Array.from({ length: formData.numContainers }).map((_, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label={`Contenedor ${index + 1}`}
                                        value={formData.containerValues[index] || ''}
                                        variant="outlined"
                                        required
                                        InputProps={{
                                            startAdornment: (
                                                <Chip
                                                    label={index + 1}
                                                    size="small"
                                                    color="primary"
                                                    sx={{
                                                        mr: 1,
                                                        fontWeight: 600,
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                    }}
                                                />
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Typography
                                                        sx={{
                                                            fontWeight: 500,
                                                            color: 'text.secondary',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        Kg
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                            inputProps: {
                                                min: 0,
                                                step: "0.01",
                                                style: { textAlign: 'right', paddingRight: '45px' }
                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                                },
                                                '&.Mui-focused': {
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                                }
                                            },
                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                display: 'none'
                                            },
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield'
                                            }
                                        }}
                                        helperText="Ingrese el peso en kilogramos"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                const newValues = [...formData.containerValues];
                                                newValues[index] = value;
                                                setFormData({ ...formData, containerValues: newValues });
                                            }
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Paper>
                </Box>
            </DialogContent>

            <DialogActions sx={{
                p: { xs: 2, sm: 3 }, // Reduced padding on mobile
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' }, // Stack buttons vertically on mobile
                justifyContent: 'center',
                alignItems: 'center',
                gap: { xs: 1, sm: 2 }, // Reduced gap on mobile
                width: '100%'
            }}>
                {deliveryStatus?.status === 'cancelled' ? (
                    <>
                        <Button
                            variant="contained"
                            onClick={() => onSubmit('cancelled')}
                            startIcon={<Close sx={{ color: 'white' }} />}
                            sx={{
                                ml: { xs: 1, sm: 1 }, // Add margin on desktop
                                bgcolor: '#DC2626',
                                width: { xs: '100%', sm: '200px' }, // Full width on mobile
                                maxWidth: { xs: '280px', sm: '200px' }, // Limit max width
                                py: { xs: 1, sm: 1.5 }, // Reduced padding on mobile
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(220, 38, 38, 0.25)',
                                transition: 'all 0.3s ease-in-out',
                                fontSize: { xs: '0.875rem', sm: '1rem' }, // Smaller font on mobile
                                '&:hover': {
                                    bgcolor: '#B91C1C',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 8px rgba(220, 38, 38, 0.35)'
                                },
                                '&:disabled': {
                                    bgcolor: '#FCA5A5',
                                    color: 'white'
                                }
                            }}
                        >
                            Guardar cambios
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => onSubmit('completed')}
                            disabled={!formData.containerValues.every(val => val.trim() !== '')}
                            sx={{
                                bgcolor: '#10B981',
                                width: { xs: '100%', sm: '200px' }, // Full width on mobile
                                maxWidth: { xs: '280px', sm: '200px' }, // Limit max width
                                py: { xs: 1, sm: 1.5 }, // Reduced padding on mobile
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(16, 185, 129, 0.25)',
                                transition: 'all 0.3s ease-in-out',
                                fontSize: { xs: '0.875rem', sm: '1rem' }, // Smaller font on mobile
                                '&:hover': {
                                    bgcolor: '#059669',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 8px rgba(16, 185, 129, 0.35)'
                                },
                                '&:disabled': {
                                    bgcolor: '#6EE7B7',
                                    color: 'white'
                                }
                            }}
                        >
                            Completar entrega
                        </Button>
                    </>
                ) : (
                    <>
                        <Button
                            variant="contained"
                            onClick={() => onSubmit('cancelled')}
                            sx={{
                                ml: { xs: 1, sm: 1 }, // Add margin on desktop
                                bgcolor: '#DC2626',
                                width: { xs: '100%', sm: '200px' }, // Full width on mobile
                                maxWidth: { xs: '280px', sm: '200px' }, // Limit max width
                                py: { xs: 1, sm: 1.5 }, // Reduced padding on mobile
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(220, 38, 38, 0.25)',
                                transition: 'all 0.3s ease-in-out',
                                fontSize: { xs: '0.875rem', sm: '1rem' }, // Smaller font on mobile
                                '&:hover': {
                                    bgcolor: '#B91C1C',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 8px rgba(220, 38, 38, 0.35)'
                                },
                                '&:disabled': {
                                    bgcolor: '#FCA5A5',
                                    color: 'white'
                                }
                            }}
                        >
                            Reprogramar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => onSubmit('completed')}
                            disabled={!formData.containerValues.every(val => val.trim() !== '')}
                            sx={{
                                bgcolor: '#10B981',
                                width: { xs: '100%', sm: '200px' }, // Full width on mobile
                                maxWidth: { xs: '280px', sm: '200px' }, // Limit max width
                                py: { xs: 1, sm: 1.5 }, // Reduced padding on mobile
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(16, 185, 129, 0.25)',
                                transition: 'all 0.3s ease-in-out',
                                fontSize: { xs: '0.875rem', sm: '1rem' }, // Smaller font on mobile
                                '&:hover': {
                                    bgcolor: '#059669',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 8px rgba(16, 185, 129, 0.35)'
                                },
                                '&:disabled': {
                                    bgcolor: '#6EE7B7',
                                    color: 'white'
                                }
                            }}
                        >
                            {isEdit ? 'Guardar cambios' : 'Completar entrega'}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}, (prevProps, nextProps) => {
    // Comparación profunda para evitar re-renders innecesarios
    return JSON.stringify(prevProps.formData) === JSON.stringify(nextProps.formData) &&
        prevProps.open === nextProps.open &&
        prevProps.isEdit === nextProps.isEdit;
});

const OperacionesDashboard: React.FC<OperacionesDashboardProps> = ({ transportistaCorreo, inventoryItems, handleLogout }) => {
    const theme = useTheme();
    const [openPedidos, setOpenPedidos] = useState(false);
    const [openProductos, setOpenProductos] = useState(false);
    const [openInventario, setOpenInventario] = useState(false);
    const [cardSearchTerm, setCardSearchTerm] = useState('');
    const [cardCategoryFilter, setCardCategoryFilter] = useState('Todos');
    const [cardAppliedFilters, setCardAppliedFilters] = useState<{
        category: string | null;
        quantityRange: [number, number] | null;
    }>({
        category: null,
        quantityRange: null,
    });
    const [selectedItem, setSelectedItem] = useState<InventoryItem | null>(null);
    const [deliveryStatus, setDeliveryStatus] = useState<DeliveryStatus>({
        isCompleted: false,
        containerValues: [''],
        driverNote: '',
        status: undefined
    });
    // const [isViewDetailsOpen, setIsViewDetailsOpen] = useState(false);
    // const [isViewDetailsOpenOrder, setIsViewDetailsOpenOrder] = useState(false);
    const categories = ['Todos', 'Kits de popostaje perros', 'Kits de popostaje gatos', 'Accesorios', 'Productos de mantenimiento'];
    const [cardFilteredItems, setCardFilteredItems] = useState<InventoryItem[]>(inventoryItems);
    const [transportistaName, setTransportistaName] = useState("");
    const [listaRutas, serListaRutas] = useState<string[]>([]);
    const [todayRoutes, setTodayRoutes] = useState<[Route[], string, string][]>([]);
    const [selectedRoute, setSelectedRoute] = useState("");
    const [routeGroupsName, setRouteGroupsName] = useState<[string, string][]>([]);
    const [routesLoaded, setRoutesLoaded] = useState(false);
    const initializationRef = useRef(false);
    const [client, setClient] = useState<Client | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    // Add state for client details dialog
    const [selectedClient, setSelectedClient] = useState<Client | null>(null);
    // const [openClientDetails, setOpenClientDetails] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    // 1. Add new state at the top of component
    const [isDialogReady, setIsDialogReady] = useState(false);

    // 2. Replace individual dialog states with single state
    const [activeDialog, setActiveDialog] = useState<ActiveDialog>(ActiveDialog.NONE);

    // 2. Add state for filtered order items
    const [orderItems, setOrderItems] = useState<OrderInventoryItem[]>([]);
    const [selectedClientId, setSelectedClientId] = useState<string | null>(null);

    // Add new state for clients data
    const [clientsDataMap, setClientsDataMap] = useState<Record<string, any>>({});
    const [clientsData, setClientsData] = useState<ClientInfo[]>([]);

    // Inside the component, add:
    const navigate = useNavigate();

    // 2. Initialize formData state
    const [formData, setFormData] = useState<DeliveryFormData>({
        numContainers: 1,
        containerValues: [''],
        driverNote: '',
        deliveryFile: null
    });

    // Add formState before localNote
    const [formState, setFormState] = useState<DeliveryFormData>({
        numContainers: 1,
        containerValues: [''],
        driverNote: '',
        deliveryFile: null
    });

    // 2. Add new state in OperacionesDashboard component
    const [openDeliveryDialog, setOpenDeliveryDialog] = useState(false);
    const [deliveryFormData, setDeliveryFormData] = useState<DeliveryFormData>({
        numContainers: 1,
        containerValues: [''],
        driverNote: '',
        deliveryFile: null
    });
    // 3. Create local state for note
    const [localDriverNote, setLocalDriverNote] = useState(formData.driverNote);

    // 4. Create debounced update
    const debouncedUpdateFormData = useMemo(
        () => debounce((value: string) => {
            setFormData(prev => ({
                ...prev,
                driverNote: value
            }));
        }, 300),
        []
    );
    const auth = getAuth();
    const [localNote, setLocalNote] = useState(formState.driverNote || '');

    const [isEditMode, setIsEditMode] = useState(false);

    const [notification, setNotification] = useState<NotificationState>({
        open: false,
        message: '',
        type: 'success'
    });

    const [existingFileUrl, setExistingFileUrl] = useState<string | null>(null);
    useEffect(() => {
        const loadExistingFile = async () => {
            // Change 'open' to check if dialog is open 
            if (!openDeliveryDialog) return;

            const matchedRoute = todayRoutes.find(route => route[2] === selectedRoute);
            if (!matchedRoute) return;

            const routeUnionId = matchedRoute[1];
            const clientRoute = matchedRoute[0].find(route => route.clientId === selectedClient?.id);

            if (clientRoute?.deliveryFileUrl) {
                setExistingFileUrl(clientRoute.deliveryFileUrl);
            }
        };

        loadExistingFile();
    }, [openDeliveryDialog, selectedRoute, selectedClient, todayRoutes]);
    // 1. Update resetDeliveryForm function
    const resetDeliveryForm = () => {
        setDeliveryFormData({
            numContainers: 1,
            containerValues: [''],
            driverNote: '',
            deliveryFile: null
        });
        setFormData({
            numContainers: 1,
            containerValues: [''],
            driverNote: '',
            deliveryFile: null
        });
    };

    // 2. Add openDeliveryDialog handler
    const handleOpenDeliveryDialog = () => {
        const matchedRoute = todayRoutes.find(route => route[2] === selectedRoute);
        if (!matchedRoute) return;

        const clientRoute = matchedRoute[0].find(route => route.clientId === selectedClient?.id);
        if (!clientRoute) return;

        if (clientRoute.status === 'cancelled' || clientRoute.delivery_completed) {
            setIsEditMode(true);
            setFormData({
                numContainers: clientRoute.container_values?.length || 1,
                containerValues: clientRoute.container_values || [''],
                driverNote: clientRoute.note_driver || '',
                deliveryFile: null
            });
            setDeliveryStatus({
                isCompleted: clientRoute.delivery_completed || false,
                containerValues: clientRoute.container_values || [''],
                driverNote: clientRoute.note_driver || '',
                status: clientRoute.status,
                completedAt: clientRoute.updatedAt
            });
        } else {
            resetDeliveryForm();
        }
        setActiveDialog(ActiveDialog.DELEVARY);
        setOpenDeliveryDialog(true);
    };

    const getDateWithoutTime = (date: Date): Date => {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);
        return newDate;
    };

    // 3. Add handler functions
    const handleDeliverySubmit = async (status: 'completed' | 'cancelled') => {
        try {
            // Check if a client is selected
            if (!selectedClient) {
                setNotification({
                    open: true,
                    message: 'Por favor, seleccione un cliente antes de continuar.',
                    type: 'error'
                });
                return;
            }

            if (!selectedRoute) {
                throw new Error('No route selected');
            }

            const matchedRoute = todayRoutes.find(route => route[2] === selectedRoute);
            if (!matchedRoute) {
                throw new Error('Route not found in todayRoutes');
            }

            const routeUnionId = matchedRoute[1];
            const clientRoute = matchedRoute[0].find(route =>
                route.clientId === clientsData.find(client =>
                    selectedClient?.id === client.clientId)?.clientId);

            if (!clientRoute) {
                throw new Error('Client route not found');
            }

            // Referencia al documento de routeUnion
            const routeUnionDocRef = doc(db, 'routeGroups', selectedRoute, 'routesUnion', routeUnionId);
            const routeUnionDoc = await getDoc(routeUnionDocRef);

            if (!routeUnionDoc.exists()) {
                throw new Error('RouteUnion document not found');
            }

            const routeUnionData = routeUnionDoc.data();
            const routes = routeUnionData.routes || [];

            const routeIndex = routes.findIndex((r: any) => r.clientId === selectedClient?.id);
            if (routeIndex === -1) {
                throw new Error('Matching route not found for this client in routesUnion');
            }

            // Manejar la subida del archivo si existe
            let deliveryFileUrl = routeUnionData.deliveryFileUrl || null;
            if (formData.deliveryFile) {
                const storage = getStorage();
                const fileRef = ref(storage, `delivery-files/${selectedRoute}/${routeUnionId}_${Date.now()}`);

                try {
                    await uploadBytes(fileRef, formData.deliveryFile);
                    deliveryFileUrl = await getDownloadURL(fileRef);

                    if (routeUnionData.deliveryFileUrl) {
                        try {
                            const oldFileRef = ref(storage, routeUnionData.deliveryFileUrl);
                            await deleteObject(oldFileRef);
                        } catch (error) {
                            console.warn('Error al eliminar archivo anterior:', error);
                        }
                    }
                } catch (error) {
                    console.error('Error al subir archivo:', error);
                    throw new Error('Error al subir el archivo de entrega');
                }
            }

            // Asegurarse de que todos los valores sean válidos antes de actualizar
            const updatedRoutes = routes.map((route: any, index: number) => {
                if (index === routeIndex) {
                    const updatedRoute = {
                        ...route,
                        note_driver: formData.driverNote || '',
                        container_values: formData.containerValues || [],
                        delivery_completed: status === 'completed',
                        updatedBy: auth.currentUser?.uid || null,
                        status: status,
                    };

                    // Solo agregar deliveryFileUrl si existe
                    if (deliveryFileUrl) {
                        updatedRoute.deliveryFileUrl = deliveryFileUrl;
                    }

                    return updatedRoute;
                }
                return route;
            });

            // Actualizar el inventario restando las cantidades entregadas
            // Solo actualizar el inventario si no estamos en modo de edición y el status es completed
            if (!isEditMode && status === 'completed') {
                const route = routes[routeIndex];
                if (route && route.order && route.order.items) {
                    for (const orderItem of route.order.items) {
                        const inventoryItemId = orderItem.inventoryItemId;
                        const quantityToSubtract = orderItem.quantity;

                        // Referencia al documento del item en inventario
                        const inventoryItemRef = doc(db, 'inventoryItems', inventoryItemId);

                        try {
                            // Obtener el documento actual del item
                            const inventoryItemDoc = await getDoc(inventoryItemRef);

                            if (inventoryItemDoc.exists()) {
                                const currentQuantity = inventoryItemDoc.data().quantity || 0;
                                const newQuantity = Math.max(0, currentQuantity - quantityToSubtract);

                                // Actualizar la cantidad en Firebase
                                await updateDoc(inventoryItemRef, {
                                    quantity: newQuantity
                                });
                            }
                        } catch (error) {
                            console.error(`Error updating inventory item ${inventoryItemId}:`, error);
                            throw new Error(`Error al actualizar el inventario para el item ${inventoryItemId}`);
                        }
                    }
                }
            }

            // Actualizar el documento con las rutas y la URL del archivo
            const updateData = {
                routes: updatedRoutes,
                updatedAt: serverTimestamp(),
            };

            await setDoc(routeUnionDocRef, updateData, { merge: true });

            // Actualizar estado local
            setDeliveryStatus({
                isCompleted: status === 'completed',
                containerValues: formData.containerValues || [],
                driverNote: formData.driverNote || '',
                completedAt: serverTimestamp() as FieldValue,
                status: status,
            });

            setOpenDeliveryDialog(false);

            // Actualizar los datos locales antes de mostrar la notificación
            const updatedClientsData = clientsData.map(client => {
                if (client.clientId === selectedClient.id) {
                    return {
                        ...client,
                        delivery_completed: status === 'completed',
                        status: status
                    };
                }
                return client;
            });
            setClientsData(updatedClientsData);

            // Actualizar todayRoutes para reflejar el cambio inmediatamente
            const updatedTodayRoutes = todayRoutes.map(route => {
                if (route[2] === selectedRoute) {
                    const updatedRouteData = route[0].map(r => {
                        if (r.clientId === selectedClient.id) {
                            return {
                                ...r,
                                delivery_completed: status === 'completed',
                                status: status,
                                note_driver: formData.driverNote || '',
                                container_values: formData.containerValues || [],
                                deliveryFileUrl: deliveryFileUrl || r.deliveryFileUrl,
                                updatedAt: serverTimestamp()
                            };
                        }
                        return r;
                    });
                    return [updatedRouteData, route[1], route[2]] as [Route[], string, string];
                }
                return route;
            });
            setTodayRoutes(updatedTodayRoutes);

            // Mostrar notificación
            setNotification({
                open: true,
                message: status === 'completed' ? 'Entrega actualizada exitosamente' : 'Pedido reprogramado exitosamente',
                type: 'success'
            });

            // Esperar a que se muestre la notificación y luego redirigir
            setTimeout(() => {
                setNotification(prev => ({ ...prev, open: false }));
                setActiveDialog(ActiveDialog.PEDIDOS);
                resetDeliveryForm();
            }, 2000);

        } catch (error) {
            console.error('Error updating delivery:', error);
            setNotification({
                open: true,
                message: error instanceof Error ? error.message : 'Error al actualizar la entrega',
                type: 'error'
            });
        }
    };

    // Add useEffect to fetch all clients data
    useEffect(() => {
        const fetchClientsData = async () => {
            const uniqueClientIds = Array.from(new Set(orderItems.map(item => item.clientId)));
            const db = getFirestore();
            const newClientsData: Record<string, any> = {};

            for (const clientId of uniqueClientIds) {
                const clientSnap = await getDoc(doc(db, 'clients', clientId));
                if (clientSnap.exists()) {
                    newClientsData[clientId] = clientSnap.data();
                }
            }

            setClientsDataMap(newClientsData);
        };

        fetchClientsData();
    }, [orderItems]);
    // 6. Add effect for data loading
    useEffect(() => {
        if (activeDialog === ActiveDialog.PEDIDOS && !isDialogReady) {
            getClientData().then(() => {
                setIsDialogReady(true);
            });
        }
    }, [activeDialog]);

    // 2. Update useEffect that fetches client data
    // useEffect(() => {
    //     if (openPedidos && !isDialogReady) {
    //         getClientData().then(() => {
    //             setIsDialogReady(true);
    //         });
    //     }
    // }, [openPedidos]);

    // 2. Agrega este nuevo useEffect para manejar el estado de carga inicial
    useEffect(() => {
        const handleInitialLoading = () => {
            if (listaRutas.length > 0 && routeGroupsName.length > 0) {
                setIsInitialLoading(false);
            }
        };

        handleInitialLoading();
    }, [listaRutas, routeGroupsName]);


    // 3. Create unified close function
    const handleCloseDialogs = () => {
        setCardCategoryFilter('Todos');
        setActiveDialog(ActiveDialog.NONE);
        setIsDialogReady(false);
    };


    const getTodayRoutes = async () => {
        try {
            const date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const today = `${year}-${month}-${day}`;
            // console.log('Today:', today);

            let matchingRoutes: [Route[], string, string][] = [];

            const queries = listaRutas.map(async (routeGroupId) => {
                try {
                    // 1. Acceder a la subcolección routesUnion
                    const routesUnionRef = collection(db, `routeGroups/${routeGroupId}/routesUnion`);
                    const routesUnionSnapshot = await getDocs(query(routesUnionRef));

                    if (routesUnionSnapshot.empty) {
                        console.log(`No hay documentos en routesUnion para ${routeGroupId}`);
                        return;
                    }

                    // recorre todo routesUnionSnapshot y obten el match con la fecha de hoy osea routesUnion[j].date = today
                    // debes de guardar las rutas que se encuentran en routesUnion[j].routes en un array y retornarlas junto con el routeGroupId
                    // para intertarlos en una array [Route[], string] y luego hacer un push a matchingRoutes
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    const matchingRoutesTemp: [Route[], string, string][] = [];

                    routesUnionSnapshot.docs.forEach((routeUnion) => {
                        const routeData = routeUnion.data();
                        if (routeData.date) {
                            const routeDate = routeData.date.toDate();
                            const isSameDay =
                                getYear(routeDate) === getYear(today) &&
                                getMonth(routeDate) === getMonth(today) &&
                                getDate(routeDate) === getDate(today);

                            if (isSameDay) {
                                const routeTuple: [Route[], string, string] = [routeData.routes, routeUnion.id, routeGroupId];
                                // Verificar si ya existe una ruta con el mismo routeGroupId y routeUnion.id
                                const existingRouteIndex = matchingRoutes.findIndex(([_, unionId, id]) =>
                                    id === routeGroupId && unionId === routeUnion.id
                                );

                                if (existingRouteIndex >= 0) {
                                    // Si existe, actualizar la ruta existente
                                    matchingRoutes[existingRouteIndex] = routeTuple;
                                } else {
                                    // Si no existe o routeUnion no existe, agregar la nueva ruta
                                    if (routeUnion.exists()) {
                                        matchingRoutes.push(routeTuple);
                                    }
                                }
                            }
                        }
                    });

                    // console.log('Matching Routes:', matchingRoutesTemp);

                    // Itera la lista de routesUnion para obtener los matches
                    // const routeUnionDoc = routesUnionSnapshot.docs[0];
                    // const routesUnionData = routeUnionDoc.data();
                    // console.log('Routes Union Data:', routesUnionData);

                } catch (error) {
                    console.error(`Error procesando ${routeGroupId}:`, error);
                }
            });

            await Promise.all(queries);

            setTodayRoutes(matchingRoutes);
            // console.log('Rutas encontradas:', matchingRoutes);

        } catch (error) {
            console.error("Error general:", error);
        }
    };

    // 2. Update handleRouteSelection function
    // Update handleRouteSelection function
    const handleRouteSelection = useCallback(async (routeId: string) => {
        try {
            setSelectedRoute(routeId);
            setIsLoading(true);

            // 1. Fetch today's routes for selected route
            const routesUnionRef = collection(db, `routeGroups/${routeId}/routesUnion`);
            const routesUnionSnapshot = await getDocs(query(routesUnionRef));

            if (!routesUnionSnapshot.empty) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                let matchingRoutesTemp: [Route[], string, string][] = [];

                routesUnionSnapshot.docs.forEach((routeUnion) => {
                    const routeData = routeUnion.data();
                    if (routeData.date) {
                        const routeDate = routeData.date.toDate();
                        const isSameDay =
                            getYear(routeDate) === getYear(today) &&
                            getMonth(routeDate) === getMonth(today) &&
                            getDate(routeDate) === getDate(today);

                        if (isSameDay) {
                            matchingRoutesTemp.push([routeData.routes, routeUnion.id, routeId]);
                        }
                    }
                });

                // 2. Update todayRoutes state with the new matching routes
                setTodayRoutes(prevRoutes => {
                    // Si es una ruta unificada, reemplazar todas las rutas
                    const isUnified = routeGroupsName.find(group => 
                        group[0] === routeId && 
                        (group[1].toLowerCase().includes('unificada') || 
                         group[1].toLowerCase().includes('unificado'))
                    );

                    return isUnified ? matchingRoutesTemp : prevRoutes;
                });

                // 3. Process client data for the selected route
                const matchedRoute = matchingRoutesTemp.find(route => route[2] === routeId);
                if (matchedRoute && matchedRoute[0]) {
                    const clientsInfo = [];
                    for (const route of matchedRoute[0]) {
                        try {
                            const clientRef = doc(db, 'clients', route.clientId);
                            const clientSnap = await getDoc(clientRef);

                            if (clientSnap.exists()) {
                                const data = clientSnap.data();
                                clientsInfo.push({
                                    clientId: clientSnap.id,
                                    name: data.name,
                                    provincia: data.provincia,
                                    canton: data.canton,
                                    distrito: data.distrito,
                                    delivery_completed: Boolean(route.delivery_completed),
                                    status: route.status || (route.delivery_completed ? 'completed' : undefined)
                                });
                            }
                        } catch (error) {
                            console.error(`Error fetching client data:`, error);
                        }
                    }
                    setClientsData(clientsInfo);
                }
            }
        } catch (error) {
            console.error("Error in handleRouteSelection:", error);
            resetStates();
        } finally {
            setIsLoading(false);
        }
    }, [db, routeGroupsName]);
    // Add reset function to clean up states
    const resetStates = () => {
        setSelectedClientId(null);
        setClient(null);
        setOrderItems([]);
        setClientsDataMap({});
    };

    const handleClientSelection = useCallback((clientId: string) => {
        setSelectedClientId(clientId);
        
        // Buscar la ruta actual
        const currentRoute = todayRoutes.find(route => route[2] === selectedRoute);
        if (!currentRoute) return;

        // Encontrar los items del cliente seleccionado
        const clientRoute = currentRoute[0].find(route => route.clientId === clientId);
        if (!clientRoute?.order?.items) return;

        // Mapear los items del pedido con la información del inventario
        const mappedItems = clientRoute.order.items
            .map(orderItem => {
                const inventoryItem = inventoryItems.find(item => item.id === orderItem.inventoryItemId);
                if (inventoryItem) {
                    return {
                        ...inventoryItem,
                        orderQuantity: orderItem.quantity,
                        clientId: clientRoute.clientId,
                        routeId: clientRoute.id,
                        delivery_completed: clientRoute.delivery_completed
                    } as OrderInventoryItem;
                }
                return null;
            })
            .filter((item): item is OrderInventoryItem => item !== null);

        setOrderItems(mappedItems);
    }, [selectedRoute, todayRoutes, inventoryItems]);

    const fetchClientDetails = async (clientId: string) => {
        try {
            // Get the routes array from todayRoutes
            const matchedRoute = todayRoutes.find(route => route[2] === selectedRoute);
            if (!matchedRoute) {
                console.error('Routes not found');
                return;
            }

            // Find the route that matches clientId
            const route = matchedRoute[0].find(r => r.clientId === clientId);
            if (!route) {
                console.error('Route not found:', clientId);
                return;
            }

            // Fetch client details from Firebase
            const clientDoc = await getDoc(doc(db, 'clients', clientId));

            if (clientDoc.exists()) {
                const clientData = clientDoc.data();
                setSelectedClient({
                    id: clientDoc.id,
                    name: clientData.name || '',
                    provincia: clientData.provincia || '',
                    canton: clientData.canton || '',
                    distrito: clientData.distrito || '',
                    cedula_nacional: clientData.cedula_nacional || '',
                    phoneNumber: clientData.phoneNumber || '',
                    tipo_client: clientData.tipo_client || '',
                    tipo_compostera: clientData.tipo_compostera || '',
                    senas: clientData.senas,
                    email: clientData.email,
                    googleMapsLink: clientData.googleMapsLink,
                    wazeLink: clientData.wazeLink,
                    second_phoneNumber: clientData.second_phoneNumber
                } as Client);

                // Actualizar los items del pedido al mismo tiempo
                if (route.order?.items) {
                    const mappedItems = route.order.items
                        .map(orderItem => {
                            const inventoryItem = inventoryItems.find(item => item.id === orderItem.inventoryItemId);
                            if (inventoryItem) {
                                return {
                                    ...inventoryItem,
                                    orderQuantity: orderItem.quantity,
                                    clientId: route.clientId,
                                    routeId: route.id,
                                    delivery_completed: route.delivery_completed
                                } as OrderInventoryItem;
                            }
                            return null;
                        })
                        .filter((item): item is OrderInventoryItem => item !== null);

                    setOrderItems(mappedItems);
                }

                // Set delivery status
                setDeliveryStatus({
                    isCompleted: route.delivery_completed || false,
                    containerValues: route.container_values || [''],
                    driverNote: route.note_driver || '',
                    status: route.status,
                    completedAt: route.updatedAt
                });
            }
        } catch (error) {
            console.error('Error fetching client details:', error);
        }
    };

    // Update useEffect to trigger when selectedRoute changes
    useEffect(() => {
        if (selectedRoute) {
            handleRouteSelection(selectedRoute);
        }
    }, [selectedRoute, handleRouteSelection])

    useEffect(() => {
        const filtered = inventoryItems.filter(item => {
            const matchesSearch = item.name.toLowerCase().includes(cardSearchTerm.toLowerCase());
            const matchesCategory = cardCategoryFilter === 'Todos' || item.category === cardCategoryFilter;
            return matchesSearch && matchesCategory;
        });
        setCardFilteredItems(filtered);

        // Add new Firebase query
        const getTransportistaName = async () => {
            const transportistasRef = collection(db, 'transportistas');
            const q = query(transportistasRef, where('email', '==', transportistaCorreo));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
                const data = doc.data();
                setTransportistaName(data.name);
                serListaRutas(data.listaRutas);
            });
        };
        getTransportistaName();
        getTodayRoutes();

        //filtra las rutas que se encuentran en listaRutas con las guardada en todayRoutes[x][1]. Entonces actualiza serListaRutas


        // getNameRousteGroups();
        // console.log(todayRoutes);
        //Recorre listaRutas y encuentra el routesGroup que haga match con el routesGroup.id = listaRutas[i] 
        //y ademas debe hacer match tambien el date(el dia de hoy) = routesGroup.routesUnion[j].date
        //y de ahi sacar la lista de rutas que se encuentran en routesGroup.routesUnion[j].routes, gaurdarlas en un array y retornarlas

    }, [cardSearchTerm, cardCategoryFilter, inventoryItems]);

    useEffect(() => {
        if (notification.open) {
            const timer = setTimeout(() => {
                setNotification(prev => ({ ...prev, open: false }));
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [notification.open]);

    const filtrarRutas = useMemo(() => {
        return (listaRutas: string[], todayRoutes: [Route[], string, string][]) => {
            // Early validation
            if (!listaRutas?.length || !todayRoutes?.length) return [];

            // Create a Set of all routes for O(1) lookup
            const rutasSet = new Set(
                todayRoutes.reduce((acc, [_, __, routeId]) => {
                    return [...acc, routeId];
                }, [] as string[])
            );

            // Buscar si existe una ruta unificada
            const rutaUnificada = routeGroupsName.find(group => 
                group[1].toLowerCase().includes('unificada') || 
                group[1].toLowerCase().includes('unificado')
            );

            // Si existe una ruta unificada y está en el conjunto de rutas activas, solo devolver esa
            if (rutaUnificada && rutasSet.has(rutaUnificada[0])) {
                return [rutaUnificada[0]];
            }

            // Si no hay ruta unificada o no está activa, devolver todas las rutas filtradas
            return listaRutas.filter(ruta => rutasSet.has(ruta));
        };
    }, [routeGroupsName]); // Añadir routeGroupsName como dependencia

    // First effect for filtering routes
    useEffect(() => {
        if (!initializationRef.current && listaRutas?.length && todayRoutes?.length) {
            const filteredRoutes = filtrarRutas(listaRutas, todayRoutes);
            serListaRutas(filteredRoutes);
            
            // Si hay rutas filtradas, seleccionar la primera
            if (filteredRoutes.length > 0) {
                setSelectedRoute(filteredRoutes[0]);
                handleRouteSelection(filteredRoutes[0]); // Llamar explícitamente a handleRouteSelection
            }
            
            initializationRef.current = true;
        }
    }, [listaRutas, todayRoutes, filtrarRutas, handleRouteSelection]);

    // Second effect for loading route groups
    useEffect(() => {
        let isMounted = true;

        const loadRouteGroups = async () => {
            if (!listaRutas?.length || routesLoaded) return;
            await getNameRousteGroups();
        };

        if (isMounted && !routesLoaded) {
            loadRouteGroups();
        }

        return () => {
            isMounted = false;
        };
    }, [listaRutas, routesLoaded]);

    // Add useEffect to fetch data when dialog opens
    // useEffect(() => {
    //     if (openPedidos) {
    //         getClientData();
    //     }
    // }, [openPedidos]);


    // 6. Add useEffect to load delivery status
    useEffect(() => {
        const loadDeliveryStatus = async () => {
            if (!selectedClient || !selectedRoute) return;

            try {
                // Find the matching route from todayRoutes
                const matchedRoute = todayRoutes.find(route => route[2] === selectedRoute);
                if (!matchedRoute) return;

                // Get routeUnionId from matchedRoute
                const routeUnionId = matchedRoute[1];

                // Create the reference to the routeUnion document
                const routeUnionDocRef = doc(db, 'routeGroups', selectedRoute, 'routesUnion', routeUnionId);
                const routeUnionDoc = await getDoc(routeUnionDocRef);

                if (routeUnionDoc.exists()) {
                    const data = routeUnionDoc.data();
                    const clientRoute = data.routes.find((r: any) => r.clientId === selectedClient.id);

                    if (clientRoute) {
                        setDeliveryStatus({
                            isCompleted: clientRoute.delivery_completed || false,
                            containerValues: clientRoute.container_values || [''],
                            driverNote: clientRoute.note_driver || '',
                            status: clientRoute.status,
                            completedAt: clientRoute.updatedAt
                        });

                        if (clientRoute.delivery_completed || clientRoute.status === 'cancelled') {
                            setDeliveryFormData({
                                numContainers: clientRoute.container_values?.length || 1,
                                containerValues: clientRoute.container_values || [''],
                                driverNote: clientRoute.note_driver || '',
                                deliveryFile: clientRoute.deliveryFile || null
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Error loading delivery status:', error);
            }
        };

        loadDeliveryStatus();
    }, [selectedClient, selectedRoute, todayRoutes, db]);

    // 4. Modify actions array
    const actions = [
        {
            title: 'Pedidos',
            icon: <Assignment fontSize="large" />,
            color: 'rgb(0, 180, 216)',
            action: () => {
                if (openDeliveryDialog) {
                    setOpenDeliveryDialog(false);
                }
                handleCloseDialogs();
                setActiveDialog(ActiveDialog.PEDIDOS);
            },
            hideFromNav: true
        },
        {
            title: 'Inicio',
            icon: <Home sx={{ fontSize: 40 }} />,
            color: 'rgb(0, 180, 216)',
            action: () => {
                if (openDeliveryDialog) {
                    setOpenDeliveryDialog(false);
                }
                handleCloseDialogs();
            },
            isHome: true,
            hideFromNav: true
        },
        {
            title: 'Productos',
            icon: <LocalGroceryStore fontSize="large" />,
            color: 'rgb(0, 180, 216)',
            action: () => {
                if (openDeliveryDialog) {
                    setOpenDeliveryDialog(false);
                }
                handleCloseDialogs();
                setActiveDialog(ActiveDialog.PRODUCTOS);
            },
            hideFromNav: true
        },
        // {
        //     title: 'Inventario',
        //     icon: <Inventory fontSize="large" />,
        //     color: 'rgb(0, 180, 216)',
        //     action: () => {
        //         if (openDeliveryDialog) {
        //             setOpenDeliveryDialog(false);
        //         }
        //         handleCloseDialogs();
        //         setActiveDialog(ActiveDialog.INVENTARIO);
        //     },
        //     hideFromNav: true
        // }
    ];

    // 3. Update handlers
    const handleViewDetails = (item: InventoryItem) => {
        setSelectedItem(item);
        handleCloseDialogs();
        setActiveDialog(ActiveDialog.VIEW_DETAILS);
    };

    const handleViewDetailsOnePerson = (item: InventoryItem) => {
        setSelectedItem(item);
        handleCloseDialogs();
        setActiveDialog(ActiveDialog.VIEW_DETAILS_ORDER);
    };

    const getClientData = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const clientsInfo = [];

            // Define types for route and client structures
            type RouteClient = {
                clientId: string;
                delivery_completed?: boolean;
                status?: 'completed' | 'cancelled';
                // Add other client-specific fields
            };

            type RouteData = RouteClient[];
            type Route = [RouteData, string, string]; // [clientsData, routeId, matchingId]

            // Single function to find matching route
            const findMatchingRoute = (routes: Route[], selectedRoute: string): Route | undefined => {
                return routes.find(route => route[2] === selectedRoute);
            };

            // Find matching route
            const matchedRoute = findMatchingRoute(todayRoutes, selectedRoute);

            if (!matchedRoute) {
                console.warn(`Route with ID ${selectedRoute} not found`);
                return;
            }

            // Process clients if route has data
            if (matchedRoute[0]?.length > 0) {
                for (const route of matchedRoute[0]) {
                    try {
                        const clientRef = doc(db, 'clients', route.clientId);
                        const clientSnap = await getDoc(clientRef);

                        if (clientSnap.exists() && route) {
                            const data = clientSnap.data();
                            clientsInfo.push({
                                clientId: clientSnap.id,
                                name: data.name,
                                provincia: data.provincia,
                                canton: data.canton,
                                distrito: data.distrito,
                                delivery_completed: Boolean(route.delivery_completed),
                                status: route.status || (route.delivery_completed ? 'completed' : undefined)
                            });
                        }
                    } catch (clientError) {
                        console.error(`Error fetching client ${route.clientId}:`, clientError);
                    }
                }
            }

            setClientsData(clientsInfo);
        } catch (err) {
            setError('Error fetching client data');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    interface Route {
        id: string;
        clientId: string;
        delivery_completed?: boolean;
        order?: {
            items: {
                inventoryItemId: string;
                quantity: number;
            }[];
        };
        note_admin?: string;
        deliveryFileUrl?: string;
        status?: 'completed' | 'cancelled';
        container_values?: string[];
        note_driver?: string;
        updatedAt?: Timestamp | FieldValue;
    }

    // Add ClientDetailsDialog component
    interface ClientDetailsDialogProps {
        client: Client | null;
        open: boolean;
        onClose: () => void;
    }

    // 1. First, update z-index constants at the top
    const DIALOG_Z_INDICES = {
        BASE: 1000,
        CLIENT: 1200,
        DETAILS: 1400,
    };

    const debouncedSetFormState = debounce((value: string) => {
        setFormState(prev => ({ ...prev, driverNote: value }));
    }, 3000);

    // 2. Modify ClientDetailsDialog component
    const ClientDetailsDialog = ({ client, open, onClose }: ClientDetailsDialogProps) => {
        if (!client) return null;
        return (
            <Dialog
                open={activeDialog === ActiveDialog.CLIENTE_DETAILS}
                onClose={() => {
                    setSelectedItem(null); // Limpiar el item seleccionado
                    setExistingFileUrl(null);
                    setActiveDialog(ActiveDialog.PEDIDOS); // Volver al dialog de inventario
                }}
                maxWidth="md"
                fullWidth
                TransitionComponent={Transition} // Re-enable the optimized Transition
                transitionDuration={0} // Set duration to 0
                keepMounted // Keep dialog mounted to prevent re-renders
                PaperProps={{
                    sx: {
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                        transition: 'none', // Remove transition
                        transform: 'none !important', // Remove transform
                        maxWidth: '900px',
                        width: '91%',
                        margin: '8px',
                        mt: '-104px',
                        '&:hover': {
                            boxShadow: '0 12px 48px rgba(0, 0, 0, 0.16)'
                        },
                        height: '86vh !important',
                        // Custom scrollbar styling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            backgroundColor: 'transparent'
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0, 180, 216, 0.05)',
                            borderRadius: '10px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgb(0, 180, 216)',
                            borderRadius: '10px',
                            border: '2px solid transparent',
                            backgroundClip: 'content-box',
                            '&:hover': {
                                backgroundColor: 'rgb(0, 119, 182)',
                                cursor: 'pointer'
                            }
                        },
                        // Firefox scrollbar styling
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgb(0, 180, 216) rgba(0, 180, 216, 0.05)'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2.5,
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}
                >
                    <Typography variant="h5" component="div" fontWeight="700" sx={{ letterSpacing: '0.5px' }}>
                        Detalles del Cliente
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setSelectedItem(null); // Limpiar el item seleccionado
                            setExistingFileUrl(null);
                            setActiveDialog(ActiveDialog.PEDIDOS); // Volver al dialog de inventario
                        }}
                        sx={{
                            color: 'white',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'rotate(90deg) scale(1.1)',
                                backgroundColor: 'rgba(255, 255, 255, 0.15)'
                            }
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} mt={2}>
                            <Box
                                sx={{
                                    background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                                    p: 3.5,
                                    borderRadius: 3,
                                    color: 'white',
                                    boxShadow: '0 10px 30px rgba(0, 119, 182, 0.2)'
                                }}
                            >
                                <Box display="flex"
                                    alignItems="center"
                                    sx={{
                                        gap: 3,
                                        justifyContent: { xs: 'center', sm: 'flex-start' }
                                    }}>
                                    <Avatar sx={{
                                        width: 64,
                                        height: 64,
                                        bgcolor: 'rgba(255,255,255,0.2)',
                                        boxShadow: '0 0 0 4px rgba(255,255,255,0.1)',
                                        display: { xs: 'none', sm: 'flex' }
                                    }}>
                                        <PersonIcon sx={{ fontSize: 36 }} />
                                    </Avatar>
                                    <Box sx={{
                                        maxWidth: { xs: '100%', sm: 'calc(100% - 80px)' },
                                        width: '100%'
                                    }}>
                                        <Typography
                                            variant="h4"
                                            fontWeight="700"
                                            sx={{
                                                mb: 0.5,
                                                width: '100%',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                textAlign: { xs: 'center', sm: 'left' }  // Center on mobile, left on larger screens
                                            }}
                                        >
                                            {client.name}
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                opacity: 0.9,
                                                textAlign: { xs: 'center', sm: 'left' }  // Center on mobile, left on larger screens
                                            }}
                                        >
                                            Cédula: {client.cedula_nacional}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        {/* crea un boton "Continuar" que abra un nuevo dialog donde haya un input number que al modificar el numero con nu rango de 1 al 8, se deben de mostrar
                        abajo de este input number los inputs necesario segun el numero que tenga, si tiene 2 entonces muestra dos inputs abajo, y tiene 5 entonces muestras
                        cinco inputs abajo, estos valores de los inputs que deben setearse abajo se deben de guardar al darle al boton "Finalizar entrega". Tambien debes agregar
                        como input el de "Nota trarnsportista", este se debe actualizar en Route.note_driver al client actual que haga match con clientId, de igualmanera esta accion
                        se ejecuta al momento de darle click al boton "Finalizar entrega"*/}

                        <Grid item xs={12}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    onClick={handleOpenDeliveryDialog}
                                    startIcon={
                                        deliveryStatus.status === 'cancelled' ? (
                                            <Close sx={{ color: 'white' }} />
                                        ) : deliveryStatus.isCompleted ? (
                                            <EditIcon />
                                        ) : (
                                            <CheckCircleIcon />
                                        )
                                    }
                                    sx={{
                                        bgcolor: deliveryStatus.status === 'cancelled' ? '#DC2626' : 
                                               deliveryStatus.isCompleted ? '#ED6C02' : '#1976d2',
                                        minWidth: '250px',
                                        py: 1.5,
                                        borderRadius: 2,
                                        textTransform: 'none',
                                        boxShadow: 2,
                                        transition: 'all 0.3s ease-in-out',
                                        '&:hover': {
                                            bgcolor: deliveryStatus.status === 'cancelled' ? '#B91C1C' :
                                                    deliveryStatus.isCompleted ? '#C55A02' : '#1565c0',
                                            transform: 'translateY(-2px)',
                                            boxShadow: 4
                                        }
                                    }}
                                >
                                    {deliveryStatus.status === 'cancelled' ? 'Editar entrega reprogramada' :
                                     deliveryStatus.isCompleted ? 'Editar entrega finalizada' : 
                                     'Continuar con la entrega'}
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box
                                sx={{
                                    bgcolor: 'white',
                                    p: 3,
                                    borderRadius: 3,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    height: '100%',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-4px)'
                                    }
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={2} mb={3}>
                                    <Avatar sx={{ bgcolor: 'primary.light' }}>
                                        <LocationOnIcon />
                                    </Avatar>
                                    <Typography
                                        variant="h6"
                                        fontWeight="700"
                                        color="primary.main"
                                    >
                                        Ubicación
                                    </Typography>
                                </Box>
                                <Box pl={5}>
                                    <Box mb={2}>
                                        <Typography variant="body1" fontWeight="500" gutterBottom>
                                            {client.provincia}, {client.canton}
                                        </Typography>
                                        <Typography color="text.secondary" gutterBottom>
                                            {client.distrito}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                        <Tooltip title={client.wazeLink ? "Abrir en Waze" : "No hay enlace disponible"}>
                                            <span>
                                                <IconButton
                                                    onClick={() => window.open(client.wazeLink, '_blank')}
                                                    disabled={!client?.wazeLink}
                                                    sx={{
                                                        color: '#0078D4',
                                                        backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                                        padding: '12px',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                                            transform: 'scale(1.1)',
                                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                                        },
                                                        '&.Mui-disabled': {
                                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                            color: 'rgba(0, 0, 0, 0.26)'
                                                        }
                                                    }}
                                                >
                                                    <FaWaze style={{ fontSize: 32 }} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>

                                        <Tooltip title={client.googleMapsLink ? "Abrir en Google Maps" : "No hay enlace disponible"}>
                                            <span>
                                                <IconButton
                                                    onClick={() => window.open(client.googleMapsLink, '_blank')}
                                                    disabled={!client?.googleMapsLink}
                                                    sx={{
                                                        color: '#4285F4', // Official Google Maps blue
                                                        backgroundColor: 'rgba(66, 133, 244, 0.08)',
                                                        padding: '12px',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(66, 133, 244, 0.15)',
                                                            transform: 'scale(1.1)',
                                                            boxShadow: '0 4px 8px rgba(66, 133, 244, 0.2)'
                                                        },
                                                        '&.Mui-disabled': {
                                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                            color: 'rgba(0, 0, 0, 0.26)'
                                                        }
                                                    }}
                                                >
                                                    <GoogleIcon sx={{ fontSize: 32 }} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box
                                sx={{
                                    bgcolor: 'white',
                                    p: 3,
                                    borderRadius: 3,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    height: '100%',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-4px)'
                                    }
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={2} mb={3}>
                                    <Avatar sx={{ bgcolor: 'primary.light' }}>
                                        <PhoneIcon />
                                    </Avatar>
                                    <Typography
                                        variant="h6"
                                        fontWeight="700"
                                        color="primary.main"
                                    >
                                        Contacto
                                    </Typography>
                                </Box>

                                <Box pl={5}>
                                    <Box mb={2}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontSize: '1.1rem',
                                                color: 'text.primary'
                                            }}
                                        >
                                            +{client?.phoneNumber}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                        <Tooltip title={client.wazeLink ? "Abrir en Waze" : "No hay enlace disponible"}>
                                            <span>
                                                <IconButton
                                                    href={`tel:${client?.phoneNumber ? client.phoneNumber.replace(/\D/g, '') : ''}`}
                                                    disabled={!client?.phoneNumber}
                                                    sx={{
                                                        color: '#0078D4',
                                                        backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                                        padding: '12px',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                                            transform: 'scale(1.1)',
                                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                                        }
                                                    }}
                                                >
                                                    <PhoneIcon sx={{ fontSize: 32 }} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title={client.googleMapsLink ? "Abrir en Google Maps" : "No hay enlace disponible"}>
                                            <span>
                                                <IconButton
                                                    href={`https://wa.me/${client?.phoneNumber ? 506+client.phoneNumber.replace(/\D/g, '') : ''}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    disabled={!client?.phoneNumber}
                                                    sx={{
                                                        color: '#25D366',
                                                        backgroundColor: 'rgba(37, 211, 102, 0.08)',
                                                        padding: '12px',
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(37, 211, 102, 0.15)',
                                                            transform: 'scale(1.1)',
                                                            boxShadow: '0 4px 8px rgba(37, 211, 102, 0.2)'
                                                        }
                                                    }}
                                                >
                                                    <WhatsAppIcon sx={{ fontSize: 32 }} />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>

                        {client.senas && (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        bgcolor: 'white',
                                        p: 3,
                                        borderRadius: 3,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={2} mb={3}>
                                        <Avatar sx={{ bgcolor: 'primary.light' }}>
                                            <NoteIcon sx={{ fontSize: 24 }} />
                                        </Avatar>
                                        <Typography
                                            variant="h6"
                                            fontWeight="700"
                                            color="primary.main"
                                        >
                                            Señas
                                        </Typography>
                                    </Box>
                                    <Box pl={5}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: 'text.primary',
                                                lineHeight: 1.6
                                            }}
                                        >
                                            {client.senas}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        )}


                        {/* Mostrar note_admin si existe */}
                        {
                            selectedRoute &&
                            todayRoutes.find(([_, __, routeGroupId]) => routeGroupId === selectedRoute) && (
                                <Grid item xs={12}>
                                    {todayRoutes
                                        .find(([_, __, routeGroupId]) => routeGroupId === selectedRoute)?.[0]
                                        .find((route: Route) => route.clientId === client.id)?.note_admin && (
                                            <Box
                                                sx={{
                                                    bgcolor: 'white',
                                                    p: 3,
                                                    borderRadius: 3,
                                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                                }}
                                            >
                                                <Box display="flex" alignItems="center" gap={2} mb={3}>
                                                    <Avatar sx={{ bgcolor: 'secondary.light' }}>
                                                        <NoteIcon sx={{ fontSize: 24 }} />
                                                    </Avatar>
                                                    <Typography
                                                        variant="h6"
                                                        fontWeight="700"
                                                        color="secondary.main"
                                                    >
                                                        Nota del Administrador
                                                    </Typography>
                                                </Box>
                                                <Box pl={5}>
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            color: 'text.primary',
                                                            lineHeight: 1.6,
                                                        }}
                                                    >
                                                        {
                                                            todayRoutes
                                                                .find(([_, __, routeGroupId]) => routeGroupId === selectedRoute)?.[0]
                                                                .find((route: Route) => route.clientId === client.id)?.note_admin
                                                        }
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        )}
                                </Grid>
                            )
                        }


                        {orderItems.length > 0 ? (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        bgcolor: 'white',
                                        borderRadius: 3,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={2} p={3} sx={{ mb: -3 }}>
                                        <Avatar sx={{ bgcolor: 'primary.light' }}>
                                            <ListAltIcon sx={{ fontSize: 24 }} />
                                        </Avatar>
                                        <Typography
                                            variant="h6"
                                            fontWeight="700"
                                            color="primary.main"
                                        >
                                            Lista de pedidos
                                        </Typography>
                                    </Box>
                                    <Box sx={{
                                        flex: 1,
                                        overflow: 'auto',
                                        mt: 1,
                                        px: 1
                                    }}>
                                        <Grid container spacing={2}>
                                            {todayRoutes
                                                .find(route => route[2] === selectedRoute)?.[0]
                                                .filter(route => route.clientId === client.id)
                                                .flatMap(route =>
                                                    route.order?.items.map(orderItem => {
                                                        const inventoryItem = inventoryItems.find(item =>
                                                            item.id === orderItem.inventoryItemId
                                                        );
                                                        return inventoryItem ? {
                                                            ...inventoryItem,
                                                            orderQuantity: orderItem.quantity,
                                                            clientId: route.clientId,
                                                            routeId: route.id
                                                        } : null;
                                                    })
                                                )
                                                .filter((item): item is OrderInventoryItem => item !== null)
                                                .length === 0 ? (
                                                <Grid item xs={12}>
                                                    <Box
                                                        sx={{
                                                            bgcolor: 'white',
                                                            p: 3,
                                                            borderRadius: 3,
                                                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        <Typography color="text.secondary">
                                                            No hay items en la orden
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            ) : (
                                                todayRoutes
                                                    .find(route => route[2] === selectedRoute)?.[0]
                                                    .filter(route => route.clientId === client.id)
                                                    .flatMap(route =>
                                                        route.order?.items.map(orderItem => {
                                                            const inventoryItem = inventoryItems.find(item =>
                                                                item.id === orderItem.inventoryItemId
                                                            );
                                                            return inventoryItem ? {
                                                                ...inventoryItem,
                                                                orderQuantity: orderItem.quantity,
                                                                clientId: route.clientId,
                                                                routeId: route.id
                                                            } : null;
                                                        })
                                                    )
                                                    .filter((item): item is OrderInventoryItem => item !== null)
                                                    .map((item, index) => (
                                                        <Grid item xs={12} key={item.id}>
                                                            <Card
                                                                onClick={() => handleViewDetailsOnePerson(item)}
                                                                sx={{
                                                                    borderRadius: 3,
                                                                    boxShadow: '0 2px 04px rgba(0, 0, 0, 0.1)',
                                                                    transition: 'all 0.3s ease',
                                                                    overflow: 'visible',
                                                                    position: 'relative',
                                                                    background: 'rgba(255, 255, 255, 0.9)',
                                                                    backdropFilter: 'blur(10px)',
                                                                    '&:hover': {
                                                                        transform: 'translateY(-2px)',
                                                                        boxShadow: '0px 8px 25px rgba(0, 180, 216, 0.2)',
                                                                        backgroundColor: 'rgba(0, 180, 216, 0.03)'
                                                                    }
                                                                }}>
                                                                <Box sx={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: 16, // Cambiado de right a left
                                                                    transform: 'translateY(-50%)',
                                                                    width: 48,
                                                                    height: 48,
                                                                    borderRadius: '50%',
                                                                    backgroundColor: 'rgba(255, 193, 7, 0.95)',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    boxShadow: '0 3px 12px rgba(0,0,0,0.2)',
                                                                    border: '2px solid #fff',
                                                                    zIndex: 2,
                                                                    transition: 'all 0.3s ease'
                                                                }}>
                                                                    <Typography
                                                                        variant="h6"
                                                                        sx={{
                                                                            fontWeight: 700,
                                                                            color: 'rgba(0, 0, 0, 0.8)',
                                                                            fontSize: '1.25rem',
                                                                            textShadow: '0 1px 2px rgba(255,255,255,0.2)',
                                                                            userSelect: 'none'
                                                                        }}
                                                                    >
                                                                        {item.orderQuantity}
                                                                    </Typography>
                                                                </Box>

                                                                {/* Existing Box content with adjusted padding */}
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    p: 1.5,
                                                                    pl: 5, // Cambiado de pr a pl para dar espacio al círculo
                                                                    gap: 2
                                                                }}>
                                                                    <Box sx={{
                                                                        width: 120,
                                                                        height: 120,
                                                                        flexShrink: 0,
                                                                        borderRadius: 2,
                                                                        overflow: 'hidden',
                                                                        bgcolor: '#f0f8ff'
                                                                    }}>
                                                                        <CardMedia
                                                                            component="img"
                                                                            sx={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'contain',
                                                                                padding: 1.5
                                                                            }}
                                                                            image={item.imageUrl}
                                                                            alt={item.name}
                                                                        />
                                                                    </Box>

                                                                    {/* Contenedor de Información */}
                                                                    <Box sx={{
                                                                        flex: 1,
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        gap: 0.5,
                                                                        minWidth: 0 // Added to enable text truncation
                                                                    }}>
                                                                        <Typography variant="subtitle1" sx={{
                                                                            fontWeight: 600,
                                                                            color: 'rgb(19, 88, 116)',
                                                                            lineHeight: 1.2,
                                                                            mb: 0.5
                                                                        }}>
                                                                            {item.name}
                                                                        </Typography>

                                                                        <Box sx={{
                                                                            display: 'flex',
                                                                            gap: 1,
                                                                            flexWrap: 'wrap',
                                                                            alignItems: 'center',
                                                                            maxWidth: '100%' // Added to contain chips
                                                                        }}>
                                                                            <Chip
                                                                                label={item.category}
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                                                                    color: 'rgb(0, 180, 216)',
                                                                                    fontWeight: 500,
                                                                                    maxWidth: '100%',
                                                                                    '& .MuiChip-label': {
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis'
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </Card>
                                                        </Grid>
                                                    ))
                                            )}
                                        </Grid>
                                    </Box>
                                </Box>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        bgcolor: 'white',
                                        p: 3,
                                        borderRadius: 3,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                        textAlign: 'center'
                                    }}
                                >
                                    <Typography color="text.secondary">
                                        No hay items en este pedido
                                    </Typography>
                                </Box>
                            </Grid>
                        )}


                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    bgcolor: 'white',
                                    p: 3,
                                    borderRadius: 3,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={2} mb={3}>
                                    <Avatar sx={{ bgcolor: 'primary.light' }}>
                                        <RecyclingIcon sx={{ fontSize: 24 }} />
                                    </Avatar>
                                    <Typography
                                        variant="h6"
                                        fontWeight="700"
                                        color="primary.main"
                                    >
                                        Información de Servicio
                                    </Typography>
                                </Box>
                                <Box pl={5}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            mb: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            fontWeight="600"
                                            color="primary.main"
                                        >
                                            Tipo de Cliente:
                                        </Box>
                                        {client.tipo_client}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <Box
                                            component="span"
                                            fontWeight="600"
                                            color="primary.main"
                                        >
                                            Tipo de Compostera:
                                        </Box>
                                        {client.tipo_compostera}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>


        );
    };

    // Componente base para los diálogos
    // Update BaseDialog component animation properties
    const BaseDialog = React.memo(({ open, onClose, title, children, fullScreen }: any) => (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            transitionDuration={0}
            keepMounted
            PaperProps={{
                sx: {
                    backgroundColor: '#ffffff',
                    position: 'relative',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                    maxWidth: '900px',
                    width: '100%',
                    margin: '16px',
                    mt: '-96px',
                    transform: 'none !important',
                    transition: 'none',
                    height: '86vh !important'
                }
            }}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '20px 24px',
                    '& .MuiTypography-root': {
                        fontSize: '1.5rem',
                        fontWeight: 700,
                        // color: 'rgb(19, 88, 116)',
                        letterSpacing: '-0.01em'
                    },
                    background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                    color: 'white',
                    p: 2.5,
                    borderBottom: '1px solid rgba(255,255,255,0.1)'
                }}
            >
                <Typography component="div">
                    {title}
                </Typography>
                <IconButton
                    onClick={onClose}
                    sx={{
                        color: 'white !important',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'rotate(90deg) scale(1.1)',
                            backgroundColor: 'rgba(255, 255, 255, 0.15)'
                        }
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    padding: '24px',
                    backgroundColor: '#f8f9fa',
                    minHeight: '300px',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '4px',
                        '&:hover': {
                            background: '#666'
                        }
                    }
                }}
            >
                {children}
            </DialogContent>
        </Dialog >
    ));

    const getNameRousteGroups = async () => {
        if (!listaRutas?.length || routesLoaded) return;

        const routeGroupQuery = collection(db, 'routeGroups');
        const q = query(routeGroupQuery, where('id', 'in', listaRutas));
        const querySnapshot = await getDocs(q);

        querySnapshot.docs.forEach(doc => {
            const data = doc.data();
            setRouteGroupsName(prevState => [...prevState, [data.id, data.name]]);
        });

        setRoutesLoaded(true);
    };

    return (
        <>
            <PageWrapper>
                <GlassContainer>
                    <GlassBox>
                        <WelcomeText variant="h4">
                            Buen día, <br />
                            <span style={{
                                background: 'linear-gradient(45deg, #2a5298, rgba(42, 82, 152, 0.7))',
                                backgroundSize: '200% 200%',
                                // animation: `${gradientShift} 3s ease infinite`,
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                textShadow: '0 2px 4px rgba(42, 82, 152, 0.1)',
                                fontWeight: 600,
                                letterSpacing: '0.02em'
                            }}>
                                {transportistaName}
                            </span>
                        </WelcomeText>

                        <Box sx={{
                            maxWidth: '500px',
                            borderRadius: '15px',
                            padding: '25px',
                            background: 'rgba(255,255,255,0.15)',
                            backdropFilter: 'blur(15px)',
                            border: '1px solid rgba(255,255,255,0.3)',
                            margin: '0 auto'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%'
                            }}>
                                <StyledSelect
                                    value={selectedRoute}
                                    onChange={(e) => handleRouteSelection(e.target.value)}
                                    disabled={todayRoutes.length <= 0 || todayRoutes.some(([_, __, isActive]) => isActive === 'true')}
                                >
                                    <option value="" disabled>Seleccionar ruta</option>
                                    {(() => {
                                        // Buscar si existe una ruta unificada
                                        const rutaUnificada = routeGroupsName.find(group => 
                                            group[1].toLowerCase().includes('unificada') || 
                                            group[1].toLowerCase().includes('unificado')
                                        );

                                        // Si existe una ruta unificada, solo mostrar esa opción
                                        if (rutaUnificada) {
                                            return (
                                                <option key={rutaUnificada[0]} value={rutaUnificada[0]}>
                                                    {rutaUnificada[1]}
                                                </option>
                                            );
                                        }

                                        // Si no hay ruta unificada, mostrar todas las rutas normalmente
                                        return listaRutas.map((ruta, index) => {
                                            const routeGroup = routeGroupsName.find(group => group[0] === ruta);
                                            return (
                                                <option key={index} value={ruta}>
                                                    {routeGroup ? routeGroup[1] : ''}
                                                </option>
                                            );
                                        });
                                    })()}
                                </StyledSelect>
                            </div>
                        </Box>
                    </GlassBox>
                </GlassContainer>
            </PageWrapper>

            {/* Logout button */}
            {activeDialog === ActiveDialog.NONE && ( // Only show when no dialog is active (i.e., in "Inicio" view)
                <Box sx={{
                    position: 'fixed',
                    bottom: 120,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1302,
                }}>
                    <Button
                        onClick={handleLogout}
                        sx={{
                            minWidth: 'auto',
                            width: 56,
                            height: 56,
                            backgroundColor: 'rgba(220, 38, 38, 0.15)',
                            color: '#dc2626',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 3px 10px rgba(220, 38, 38, 0.2)',
                            borderRadius: '50%',
                            border: '2px solid rgba(220, 38, 38, 0.1)',
                            backdropFilter: 'blur(8px)',
                            '&:hover': {
                                backgroundColor: 'rgba(220, 38, 38, 0.25)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 5px 15px rgba(220, 38, 38, 0.3)',
                                border: '2px solid rgba(220, 38, 38, 0.2)'
                            },
                            '&:active': {
                                transform: 'translateY(0)',
                                boxShadow: '0 2px 8px rgba(220, 38, 38, 0.2)'
                            },
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5
                        }}
                    >
                        <ExitToAppIcon
                            sx={{
                                fontSize: 24,
                                filter: 'drop-shadow(0 2px 4px rgba(220, 38, 38, 0.2))'
                            }}
                        />
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '0.65rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                textShadow: '0 1px 2px rgba(220, 38, 38, 0.1)'
                            }}
                        >
                            Salir
                        </Typography>
                    </Button>
                </Box>
            )}

            {/* Barra inferior existente */}
            <Box sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: 'white',
                borderTop: `2px solid ${theme.palette.divider}`,
                padding: 2,
                boxShadow: '0px -2px 8px rgba(0,0,0,0.1)',
                zIndex: 1301,
            }}>
                <Grid container sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                }}>
                    {/* Botón izquierdo (Pedidos) */}
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        {actions.slice(0, 1).map((item, index) => (
                            <Button
                                key={index}
                                onClick={item.action}
                                sx={{
                                    width: '100%',
                                    maxWidth: '120px',
                                    height: 60,
                                    flexDirection: 'column',
                                    color: 'rgb(19, 88, 116)',
                                    backgroundColor: 'transparent',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 180, 216, 0.1)'
                                    }
                                }}
                            >
                                {item.icon}
                                <Typography variant="caption" sx={{
                                    textTransform: 'capitalize' // Add this line
                                }}>
                                    {item.title}
                                </Typography>
                            </Button>
                        ))}
                    </Grid>

                    {/* Botón central (Inicio) */}
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                        {actions.filter(item => item.isHome).map((item, index) => (

                            <Button
                                key={index}
                                onClick={item.action}
                                sx={{
                                    width: '120px',
                                    height: 70,
                                    flexDirection: 'column',
                                    transform: 'translateY(-10px)',
                                    backgroundColor: 'rgb(0, 180, 216)',
                                    borderRadius: '20px',
                                    color: 'white',
                                    boxShadow: '0 4px 10px rgba(0, 180, 216, 0.3)',
                                    '&:hover': {
                                        backgroundColor: 'rgb(0, 160, 196)',
                                        boxShadow: '0 6px 12px rgba(0, 180, 216, 0.4)',
                                    }
                                }}
                            >
                                {item.icon}
                                <Typography variant="caption" sx={{
                                    textTransform: 'capitalize' // Add this line
                                }}>
                                    {item.title}
                                </Typography>
                            </Button>
                        ))}
                    </Grid>

                    {/* Botones derecha (Productos y Salir) */}
                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {actions.slice(2).map((item, index) => (
                            <Button
                                key={index}
                                onClick={item.action}
                                sx={{
                                    width: '100%',
                                    maxWidth: '120px',
                                    height: 60,
                                    flexDirection: 'column',
                                    color: 'rgb(19, 88, 116)',
                                    backgroundColor: 'transparent',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 180, 216, 0.1)'
                                    }
                                }}
                            >
                                {item.icon}
                                <Typography variant="caption" sx={{
                                    textTransform: 'capitalize' // Add this line
                                }}>
                                    {item.title}
                                </Typography>
                            </Button>
                        ))}
                    </Grid>
                </Grid>
            </Box>

            <BaseDialog
                open={activeDialog === ActiveDialog.PEDIDOS}
                onClose={handleCloseDialogs}
                title="Pedidos de la ruta"
            >
                <Box sx={{
                    // height: 'calc(90vh - 64px)', // Account for dialog title
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    // background: 'linear-gradient(-45deg, #135874, #00B4D8, #0077B6, #023E8A)',
                    backgroundSize: '400% 400%',
                    backgroundAttachment: 'fixed',
                    // p: 3,
                }}>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    {todayRoutes.length > 0 ? (
                        <Box
                            sx={{
                                position: 'relative',
                                zIndex: 1,
                                flex: 1,
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    borderRadius: '4px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: 'rgba(255, 255, 255, 0.3)',
                                    borderRadius: '4px',
                                    '&:hover': {
                                        background: 'rgba(255, 255, 255, 0.5)',
                                    },
                                },
                            }}
                        >
                            <Grid container spacing={2}>
                                {clientsData.map((client, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <ClientCard
                                            onClick={() => {
                                                fetchClientDetails(clientsData[index].clientId);
                                                setActiveDialog(ActiveDialog.CLIENTE_DETAILS);
                                            }}
                                            sx={{
                                                position: 'relative',
                                                pl: 7, // Add padding for circle
                                                '&::before': {
                                                    content: `"${index + 1}"`,
                                                    position: 'absolute',
                                                    left: 16,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: 32,
                                                    height: 32,
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                                                    color: 'white',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 'bold',
                                                    boxShadow: '0 2px 8px rgba(0, 119, 182, 0.2)'
                                                }
                                            }}
                                        >
                                            <Typography variant="h6" color="primary" gutterBottom>
                                                {client.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {client.provincia}, {client.canton}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {client.distrito}
                                            </Typography>
                                            {/* Add check icon for completed deliveries */}
                                            {todayRoutes
                                                .find(route => route[2] === selectedRoute)?.[0]
                                                .find((route: Route) => route.clientId === client.clientId)?.status === 'cancelled' ? (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        right: 16,
                                                        top: 44,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <Close
                                                        sx={{
                                                            color: '#DC2626',
                                                            fontSize: 36,
                                                            filter: 'drop-shadow(0 2px 4px rgba(220, 38, 38, 0.3))',
                                                            transition: 'transform 0.2s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.1)',
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            ) : client.delivery_completed && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        right: 16,
                                                        top: 44,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <CheckCircleIcon
                                                        sx={{
                                                            color: '#10B981',
                                                            fontSize: 36,
                                                            filter: 'drop-shadow(0 2px 4px rgba(16, 185, 129, 0.3))',
                                                            transition: 'transform 0.2s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.1)',
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                        </ClientCard>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    ) : (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '70vh'
                        }} >
                            <Typography variant="h5" component="div" sx={{ color: 'rgb(19, 88, 116)', textAlign: 'center' }}>
                                No hay pedidos disponibles
                            </Typography>
                        </Box >
                    )}
                </Box>
            </BaseDialog>

            <BaseDialog
                open={activeDialog === ActiveDialog.PRODUCTOS}
                onClose={handleCloseDialogs}
                title="Productos de la ruta"
            >
                <Box
                    sx={{
                        // height: 'calc(90vh - 64px)', // Account for dialog title
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        // background: 'linear-gradient(-45deg, #135874, #00B4D8, #0077B6, #023E8A)',
                        backgroundSize: '400% 400%',
                        backgroundAttachment: 'fixed',
                        mt: 1,
                        // p: 3,
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            zIndex: 1,
                            flex: 1,
                            overflowY: 'auto',
                            '&::-webkit-scrollbar': {
                                width: '10px',
                                background: 'transparent'
                            },
                            '&::-webkit-scrollbar-track': {
                                background: 'rgba(0, 180, 216, 0.05)',
                                borderRadius: '8px',
                                border: '1px solid rgba(0, 180, 216, 0.1)',
                                boxShadow: 'inset 0 0 6px rgba(0, 119, 182, 0.1)'
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: 'linear-gradient(180deg, #00B4D8 0%, #0077B6 100%)',
                                borderRadius: '8px',
                                border: '2px solid transparent',
                                backgroundClip: 'padding-box',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: 'linear-gradient(180deg, #00B4D8 30%, #0077B6 90%)',
                                    boxShadow: '0 0 12px rgba(0, 180, 216, 0.3)'
                                }
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: 'transparent'
                            }
                        }}
                    >
                        {(() => {
                            const filteredProducts = Object.values(
                                todayRoutes
                                    .flatMap(route =>
                                        route[0].flatMap(routeItem =>
                                            // Solo incluir items si el pedido no está cancelado
                                            !routeItem.status || routeItem.status !== 'cancelled' ?
                                            routeItem.order?.items.map(orderItem => {
                                                const inventoryItem = inventoryItems.find(item =>
                                                    item.id === orderItem.inventoryItemId
                                                );
                                                return inventoryItem ? {
                                                    ...inventoryItem,
                                                    orderQuantity: orderItem.quantity,
                                                    clientId: routeItem.clientId,
                                                    routeId: routeItem.id,
                                                    delivery_completed: routeItem.delivery_completed
                                                } : null;
                                            }) : []
                                        )
                                    )
                                    .filter((item): item is OrderInventoryItem & { delivery_completed: boolean | undefined } =>
                                        item !== null && item !== undefined && !item.delivery_completed
                                    )
                                    .reduce((acc: Record<string, OrderInventoryItem>, curr) => {
                                        if (!acc[curr.id]) {
                                            acc[curr.id] = { ...curr };
                                        } else {
                                            acc[curr.id].orderQuantity += curr.orderQuantity;
                                        }
                                        return acc;
                                    }, {})
                            );

                            return filteredProducts.length > 0 ? (
                                <Grid container spacing={2}>
                                    {/* Aggregate quantities across all routes */}
                                    {filteredProducts.map((item, index) => (
                                        <Grid item xs={12} key={item.id}>
                                            <Card sx={{
                                                borderRadius: 3,
                                                boxShadow: '0 2px 04px rgba(0, 0, 0, 0.1)',
                                                transition: 'all 0.3s ease',
                                                overflow: 'visible',
                                                position: 'relative',
                                                background: 'rgba(255, 255, 255, 0.9)',
                                                backdropFilter: 'blur(10px)',
                                                // '&:hover': {
                                                //     transform: 'translateY(-2px)',
                                                //     boxShadow: '0 4px 15px rgba(0,0,0,0.25)',
                                                //     backgroundColor: 'rgba(255, 193, 7, 1)'
                                                // }
                                            }}>
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: 16, // Cambiado de right a left
                                                    transform: 'translateY(-50%)',
                                                    width: 48,
                                                    height: 48,
                                                    borderRadius: '50%',
                                                    backgroundColor: 'rgba(255, 193, 7, 0.95)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: '0 3px 12px rgba(0,0,0,0.2)',
                                                    border: '2px solid #fff',
                                                    zIndex: 2,
                                                    transition: 'all 0.3s ease',
                                                }}>
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: 'rgba(0, 0, 0, 0.8)',
                                                            fontSize: '1.25rem',
                                                            textShadow: '0 1px 2px rgba(255,255,255,0.2)',
                                                            userSelect: 'none'
                                                        }}
                                                    >
                                                        {item.orderQuantity}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    p: 1.5,
                                                    pl: 5, // Cambiado de pr a pl para dar espacio al círculo
                                                    gap: 2
                                                }}>
                                                    <Box sx={{
                                                        width: 120,
                                                        height: 120,
                                                        flexShrink: 0,
                                                        borderRadius: 2,
                                                        overflow: 'hidden',
                                                        bgcolor: '#f0f8ff'
                                                    }}>
                                                        <CardMedia
                                                            component="img"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                padding: 1.5
                                                            }}
                                                            image={item.imageUrl}
                                                            alt={item.name}
                                                        />
                                                    </Box>

                                                    <Box sx={{
                                                        flex: 1,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 0.5,
                                                        minWidth: 0
                                                    }}>
                                                        <Typography variant="subtitle1" sx={{
                                                            fontWeight: 600,
                                                            color: 'rgb(19, 88, 116)',
                                                            lineHeight: 1.2,
                                                            mb: 0.5
                                                        }}>
                                                            {item.name}
                                                        </Typography>

                                                        <Box sx={{
                                                            display: 'flex',
                                                            gap: 1,
                                                            flexWrap: 'wrap',
                                                            alignItems: 'center'
                                                        }}>
                                                            <Chip
                                                                label={item.category}
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                                                    color: 'rgb(0, 180, 216)',
                                                                    fontWeight: 500
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))
                                    }
                                </Grid>
                            ) : (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '70vh'
                                }} >
                                    <Typography variant="h5" component="div" sx={{ color: 'rgb(19, 88, 116)', textAlign: 'center' }}>
                                        No hay productos en la ruta
                                    </Typography>
                                </Box>
                            );
                        })()}
                    </Box>
                </Box>
            </BaseDialog>

            <BaseDialog
                open={activeDialog === ActiveDialog.INVENTARIO}
                onClose={handleCloseDialogs}
                title="Inventario disponible"
            >
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    {/* Sección de Filtros */}
                    <Box sx={{
                        mt: 2,
                        p: 1,
                        backgroundColor: 'white',
                        boxShadow: theme.shadows[1],
                        zIndex: 1
                    }}>
                        {/* Filtros */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 1,
                            alignItems: 'center',
                            mb: 1
                        }}>
                            {/* <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Buscar..."
                                value={cardSearchTerm}
                                onChange={(e) => setCardSearchTerm(e.target.value)}
                                InputProps={{
                                    startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                                }}
                            /> */}

                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Categoría</InputLabel>
                                <Select
                                    value={cardCategoryFilter}
                                    onChange={(e: SelectChangeEvent<string>) => {
                                        const category = e.target.value;
                                        setCardCategoryFilter(category);
                                    }}
                                    label="Categoría"
                                    sx={{ height: '40px' }}
                                >
                                    {categories.map((category) => (
                                        <MenuItem key={category} value={category}>{category}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Filtros aplicados */}
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            mt: 1
                        }}>
                            {cardAppliedFilters.category && (
                                <Chip
                                    label={`Categoría: ${cardAppliedFilters.category}`}
                                    onDelete={() => setCardAppliedFilters(prev => ({ ...prev, category: null }))}
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: 'rgb(0, 180, 216)',
                                        color: 'white',
                                        '& .MuiChip-deleteIcon': { color: 'white' }
                                    }}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* Lista de Productos con diseño alternado */}
                    <Box sx={{
                        flex: 1,
                        overflow: 'auto',
                        mt: 1,
                        px: 1,
                        // Custom scrollbar styling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            backgroundColor: 'transparent'
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0, 180, 216, 0.05)',
                            borderRadius: '10px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgb(0, 180, 216)',
                            borderRadius: '10px',
                            border: '2px solid transparent',
                            backgroundClip: 'content-box',
                            '&:hover': {
                                backgroundColor: 'rgb(0, 119, 182)',
                                cursor: 'pointer'
                            }
                        },
                        // Firefox scrollbar styling
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgb(0, 180, 216) rgba(0, 180, 216, 0.05)'
                    }}>
                        <Grid container spacing={2}>
                            {cardFilteredItems.map((item, index) => (
                                <Grid item xs={12} key={item.id}>
                                    <Card
                                        onClick={() => handleViewDetails(item)}
                                        sx={{
                                            borderRadius: 3,
                                            boxShadow: 2,
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            overflow: 'hidden',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0px 8px 25px rgba(0, 180, 216, 0.2)',
                                                backgroundColor: 'rgba(0, 180, 216, 0.03)'
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                handleViewDetails(item);
                                            }
                                        }}
                                    >
                                        {/* Title Box */}
                                        <Box sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                            p: 1, // Reduced from p: 2
                                            pb: 0.5 // Add bottom padding
                                        }}>
                                            <Typography variant="subtitle1" sx={{
                                                fontWeight: 600,
                                                color: 'rgb(19, 88, 116)',
                                                lineHeight: 1.2, // Reduced from 1.4
                                                padding: '0.25rem 0.5rem', // Reduced padding
                                                wordBreak: 'break-word',
                                                fontSize: '0.9rem',
                                                margin: 0 // Remove margin
                                            }}>
                                                {item.name}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start', // Changed to flex-start
                                            p: 1,
                                            mx: 'auto',
                                            maxWidth: '95%',
                                            gap: 1, // Reduced gap
                                            border: '1px solid rgba(0, 180, 216, 0.1)',
                                            borderRadius: 2,
                                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                            boxShadow: '0 0 10px rgba(0, 180, 216, 0.05)',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                                border: '1px solid rgba(0, 180, 216, 0.2)'
                                            }
                                        }}>
                                            {/* Image Box - Left Aligned */}
                                            <Box sx={{
                                                width: 70, // Slightly smaller
                                                height: 70, // Slightly smaller
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                                borderRadius: 1,
                                                overflow: 'hidden',
                                                bgcolor: '#f0f8ff',
                                                border: '1px solid rgba(0, 180, 216, 0.1)',
                                                mr: 1 // Add right margin to create space with text
                                            }}>
                                                <CardMedia
                                                    component="img"
                                                    sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain',
                                                        padding: 0.5
                                                    }}
                                                    image={item.imageUrl}
                                                    alt={item.name}
                                                />
                                            </Box>

                                            {/* Contenedor de Información */}

                                            <Box sx={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 0.5,
                                                textAlign: 'center'
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: 0.5
                                                }}>
                                                    <Inventory fontSize="small" sx={{ color: 'rgb(19, 88, 116)' }} />
                                                    <Typography variant="body2" sx={{
                                                        color: 'rgb(19, 88, 116)',
                                                        fontWeight: 500,
                                                        fontSize: '0.875rem'
                                                    }}>
                                                        Cant: {item.quantity}
                                                    </Typography>
                                                </Box>

                                                <Typography variant="h6" sx={{
                                                    color: 'rgb(0, 180, 216)',
                                                    fontWeight: 700,
                                                    fontSize: '1rem'
                                                }}>
                                                    ₡{item.price.toLocaleString()}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            width: '100%',
                                            p: 0.5
                                        }}>
                                            <Chip
                                                label={item.category}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                                    color: 'rgb(0, 180, 216)',
                                                    fontWeight: 500,
                                                    mb: 0.5, // Reduced from 1
                                                    height: '24px' // Added for smaller height
                                                }}
                                            />
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
            </BaseDialog>

            {/* View Details Dialog */}
            <Dialog
                open={activeDialog === ActiveDialog.VIEW_DETAILS}
                onClose={() => {
                    setSelectedItem(null); // Limpiar el item seleccionado
                    setActiveDialog(ActiveDialog.INVENTARIO); // Volver al dialog de inventario
                }}
                maxWidth="md"
                fullWidth
                TransitionComponent={Transition} // Re-enable the optimized Transition
                transitionDuration={0} // Set duration to 0
                keepMounted // Keep dialog mounted to prevent re-renders
                PaperProps={{
                    sx: {
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                        transition: 'none', // Remove transition
                        transform: 'none !important', // Remove transform
                        maxWidth: '900px',
                        width: '91%',
                        margin: '8px',
                        mt: '-104px',
                        '&:hover': {
                            boxShadow: '0 12px 48px rgba(0, 0, 0, 0.16)'
                        },
                        height: '86vh !important',
                        // Custom scrollbar styling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            backgroundColor: 'transparent'
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0, 180, 216, 0.05)',
                            borderRadius: '10px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgb(0, 180, 216)',
                            borderRadius: '10px',
                            border: '2px solid transparent',
                            backgroundClip: 'content-box',
                            '&:hover': {
                                backgroundColor: 'rgb(0, 119, 182)',
                                cursor: 'pointer'
                            }
                        },
                        // Firefox scrollbar styling
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgb(0, 180, 216) rgba(0, 180, 216, 0.05)'
                    }
                }}
            >
                {/* Rest of dialog content remains the same */}
                <DialogTitle
                    sx={{
                        background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2.5,
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}
                >
                    <Typography variant="h5" component="div" fontWeight="700" sx={{ letterSpacing: '0.5px' }}>
                        Detalles del Producto
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setSelectedItem(null); // Limpiar el item seleccionado
                            setActiveDialog(ActiveDialog.INVENTARIO); // Volver al dialog de inventario
                        }}
                        sx={{
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'rotate(90deg) scale(1.1)',
                                backgroundColor: 'rgba(255, 255, 255, 0.15)'
                            }
                        }}
                    >
                        <Close sx={{
                            color: 'white'
                        }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{
                    p: 3,
                    backgroundColor: '#f8f9fa',
                    minHeight: '400px'
                }}>
                    {selectedItem && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}>
                                    <img src={selectedItem.imageUrl} alt={selectedItem.name} style={{
                                        maxWidth: '100%',
                                        maxHeight: '300px',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    p: 3,
                                    height: '100%',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    // Add overflow handling
                                    overflow: 'auto',
                                    // Add custom scrollbar styling
                                    '&::-webkit-scrollbar': {
                                        width: '8px'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1'
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '4px'
                                    }
                                }}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        sx={{
                                            color: 'rgb(19, 88, 116)',
                                            fontWeight: 'bold',
                                            mb: 2,
                                            // Add text overflow handling
                                            overflow: 'visible',
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >{selectedItem.name}</Typography>
                                    <Typography
                                        variant="h5"
                                        component="div"
                                        sx={{
                                            color: '#00b4d8',
                                            mb: 3,
                                            fontWeight: '600'
                                        }}
                                    >₡{selectedItem.price.toLocaleString()}</Typography>
                                    <Box sx={{
                                        backgroundColor: '#f8f9fa',
                                        p: 2,
                                        borderRadius: '8px',
                                        mb: 3
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Categoría
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.category}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Cantidad
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.quantity} unidades
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Color
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.color || 'N/A'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Tamaño
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.tamano || 'N/A'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        sx={{
                                            color: 'rgb(19, 88, 116)',
                                            fontWeight: '600',
                                            mb: 1
                                        }}
                                    >
                                        Descripción
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: 'text.secondary',
                                            lineHeight: 1.6
                                        }}
                                    >
                                        {selectedItem.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                    )}
                </DialogContent>
            </Dialog>

            <Dialog
                open={activeDialog === ActiveDialog.VIEW_DETAILS_ORDER}
                onClose={handleCloseDialogs}
                maxWidth="md"
                fullWidth
                TransitionComponent={Transition} // Re-enable the optimized Transition
                transitionDuration={0} // Set duration to 0
                keepMounted // Keep dialog mounted to prevent re-renders
                PaperProps={{
                    sx: {
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        overflow: 'hidden',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                        transition: 'none', // Remove transition
                        transform: 'none !important', // Remove transform
                        maxWidth: '900px',
                        width: '91%',
                        margin: '8px',
                        mt: '-104px',
                        '&:hover': {
                            boxShadow: '0 12px 48px rgba(0, 0, 0, 0.16)'
                        },
                        height: '86vh !important',
                        // Custom scrollbar styling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                            backgroundColor: 'transparent'
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0, 180, 216, 0.05)',
                            borderRadius: '10px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgb(0, 180, 216)',
                            borderRadius: '10px',
                            border: '2px solid transparent',
                            backgroundClip: 'content-box',
                            '&:hover': {
                                backgroundColor: 'rgb(0, 119, 182)',
                                cursor: 'pointer'
                            }
                        },
                        // Firefox scrollbar styling
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgb(0, 180, 216) rgba(0, 180, 216, 0.05)'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        background: 'linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2.5,
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}
                >
                    <Typography variant="h5" component="div" fontWeight="700">Detalles del Producto</Typography>
                    <IconButton
                        onClick={() => {
                            setSelectedItem(null); // Limpiar el item seleccionado
                            setActiveDialog(ActiveDialog.CLIENTE_DETAILS); // Volver al dialog de inventario
                        }}
                        sx={{
                            color: 'white',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                transform: 'rotate(90deg) scale(1.1)',
                                backgroundColor: 'rgba(255, 255, 255, 0.15)'
                            }
                        }}
                    >
                        <Close sx={{ color: 'white' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{
                    p: 3,
                    backgroundColor: '#f8f9fa',
                    minHeight: '400px'
                }}>
                    {selectedItem && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Box sx={{
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                }}>
                                    <img
                                        src={selectedItem.imageUrl}
                                        alt={selectedItem.name}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '300px',
                                            objectFit: 'contain',
                                            borderRadius: '8px'
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box sx={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    p: 3,
                                    height: '100%',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    // Add overflow handling
                                    overflow: 'auto',
                                    // Add custom scrollbar styling
                                    '&::-webkit-scrollbar': {
                                        width: '8px'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1'
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '4px'
                                    }
                                }}>
                                    <Typography
                                        variant="h4"
                                        gutterBottom
                                        sx={{
                                            color: 'rgb(19, 88, 116)',
                                            fontWeight: 'bold',
                                            mb: 2,
                                            // Add text overflow handling
                                            overflow: 'visible',
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {selectedItem.name}
                                    </Typography>
                                    <Box sx={{
                                        backgroundColor: '#f8f9fa',
                                        p: 2,
                                        borderRadius: '8px',
                                        mb: 3
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Categoría
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.category}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Color
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.color || 'N/A'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" color="text.secondary">
                                                    Tamaño
                                                </Typography>
                                                <Typography variant="body1" fontWeight="500">
                                                    {selectedItem.tamano || 'N/A'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        sx={{
                                            color: 'rgb(19, 88, 116)',
                                            fontWeight: '600',
                                            mb: 1
                                        }}
                                    >
                                        Descripción
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: 'text.secondary',
                                            lineHeight: 1.6
                                        }}
                                    >
                                        {selectedItem.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
            </Dialog>

            <ClientDetailsDialog
                client={selectedClient}
                open={activeDialog === ActiveDialog.CLIENTE_DETAILS}
                onClose={() => {
                    setSelectedItem(null); // Limpiar el item seleccionado
                    setExistingFileUrl(null);
                    setActiveDialog(ActiveDialog.PEDIDOS); // Volver al dialog de inventario
                }}
            />

            <DeliveryDialog
                open={activeDialog === ActiveDialog.DELEVARY}
                onClose={() => {
                    resetDeliveryForm();
                    setActiveDialog(ActiveDialog.CLIENTE_DETAILS);
                }}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleDeliverySubmit}
                isEdit={isEditMode}
                existingFileUrl={existingFileUrl}
                deliveryStatus={deliveryStatus}
            />

            <Dialog
                open={notification.open}
                fullScreen
                TransitionComponent={Slide}
                sx={{
                    '& .MuiDialog-paper': {
                        margin: 0,
                        background: 'rgba(0, 0, 0, 0.85)',
                        backdropFilter: 'blur(8px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        color: 'white',
                        p: 4,
                        maxWidth: '80%'
                    }}
                >
                    <Box sx={{ position: 'relative', mb: 3 }}>
                        <CheckCircleIcon
                            sx={{
                                fontSize: 100,
                                animation: `${checkAnimation} 1s cubic-bezier(0.4, 0, 0.2, 1)`,
                                color: notification.type === 'success' ? '#10B981' : '#EF4444'
                            }}
                        />
                    </Box>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 600,
                            mb: 2,
                            animation: `${fadeIn} 0.5s ease-out 0.5s forwards`,
                            opacity: 0
                        }}
                    >
                        {notification.type === 'success' ? '¡Operación Exitosa!' : '¡Error!'}
                    </Typography>
                    <Typography
                        sx={{
                            opacity: 0,
                            animation: `${fadeIn} 0.5s ease-out 0.7s forwards`,
                            fontSize: '1.1rem'
                        }}
                    >
                        {notification.message}
                    </Typography>
                </Box>
            </Dialog>
        </>
    );
}

export default OperacionesDashboard;

// cedula_nacional, phoneNumber, tipo_client, tipo_comnpostera, nota,


